/**
 * Auto-generated Locale Data File for ru-RU.
 * This is generated in the @box/cldr-data project.
 * @IMPORTANT: DO NOT MODIFY THIS FILE DIRECTLY
 */

import type { NumberFormat, NumbersData, NameItem, LanguagesData, LocaleData, TimeZone, TimeZoneList, WeekData, WeekDayNameData, NameSet, WeekDayNames } from '../types';

const languages: LanguagesData = {
    id: 8,
    bcp47Tag: 'ru-RU',
    name: 'Russian',
    localizedName: 'Русский',
    localizedNameList: [
        {
            id: 67,
            name: 'австралийский английский',
        },
        {
            id: 4,
            name: 'английский',
        },
        {
            id: 70,
            name: 'бенгальский',
        },
        {
            id: 59,
            name: 'британский английский',
        },
        {
            id: 68,
            name: 'датский',
        },
        {
            id: 10,
            name: 'испанский',
        },
        {
            id: 16,
            name: 'итальянский',
        },
        {
            id: 66,
            name: 'канадский английский',
        },
        {
            id: 65,
            name: 'канадский французский',
        },
        {
            id: 63,
            name: 'китайский, традиционное письмо',
        },
        {
            id: 6,
            name: 'китайский, упрощенное письмо',
        },
        {
            id: 55,
            name: 'корейский',
        },
        {
            id: 72,
            name: 'латиноамериканский испанский',
        },
        {
            id: 18,
            name: 'немецкий',
        },
        {
            id: 24,
            name: 'нидерландский',
        },
        {
            id: 69,
            name: 'норвежский букмол',
        },
        {
            id: 30,
            name: 'польский',
        },
        {
            id: 14,
            name: 'португальский',
        },
        {
            id: 8,
            name: 'русский',
        },
        {
            id: 49,
            name: 'турецкий',
        },
        {
            id: 61,
            name: 'финский',
        },
        {
            id: 21,
            name: 'французский',
        },
        {
            id: 71,
            name: 'хинди',
        },
        {
            id: 57,
            name: 'шведский',
        },
        {
            id: 19,
            name: 'японский',
        },
    ],
};

const numbers: NumbersData = {
    long: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, plural, other {# тысячи} one {# тысяча} many {# тысяч}}',
        },
        {
            digits: 2,
            msg: '{count, plural, other {# тысячи} one {# тысяча} many {# тысяч}}',
        },
        {
            digits: 3,
            msg: '{count, plural, other {# тысячи} one {# тысяча} many {# тысяч}}',
        },
        {
            digits: 1,
            msg: '{count, plural, other {# миллиона} one {# миллион} many {# миллионов}}',
        },
        {
            digits: 2,
            msg: '{count, plural, other {# миллиона} one {# миллион} many {# миллионов}}',
        },
        {
            digits: 3,
            msg: '{count, plural, other {# миллиона} one {# миллион} many {# миллионов}}',
        },
        {
            digits: 1,
            msg: '{count, plural, other {# миллиарда} one {# миллиард} many {# миллиардов}}',
        },
        {
            digits: 2,
            msg: '{count, plural, other {# миллиарда} one {# миллиард} many {# миллиардов}}',
        },
        {
            digits: 3,
            msg: '{count, plural, other {# миллиарда} one {# миллиард} many {# миллиардов}}',
        },
        {
            digits: 1,
            msg: '{count, plural, other {# триллиона} one {# триллион} many {# триллионов}}',
        },
        {
            digits: 2,
            msg: '{count, plural, other {# триллиона} one {# триллион} many {# триллионов}}',
        },
    ],
    short: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number} тыс.',
        },
        {
            digits: 2,
            msg: '{count, number} тыс.',
        },
        {
            digits: 3,
            msg: '{count, number} тыс.',
        },
        {
            digits: 1,
            msg: '{count, number} млн',
        },
        {
            digits: 2,
            msg: '{count, number} млн',
        },
        {
            digits: 3,
            msg: '{count, number} млн',
        },
        {
            digits: 1,
            msg: '{count, number} млрд',
        },
        {
            digits: 2,
            msg: '{count, number} млрд',
        },
        {
            digits: 3,
            msg: '{count, number} млрд',
        },
        {
            digits: 1,
            msg: '{count, number} трлн',
        },
        {
            digits: 2,
            msg: '{count, number} трлн',
        },
    ],
};

const timezones: Array<TimeZone> = [
    {
        name: 'Pacific/Kiritimati',
        displayName: 'GMT+14:00 Киритимати +14',
        nameLocalized: 'Киритимати',
        abbreviationStandard: '+14',
        id: 500,
        enabled: true
    },
    {
        name: 'Etc/GMT-14',
        displayName: 'GMT+14:00 GMT-14 +14',
        nameLocalized: 'GMT-14',
        abbreviationStandard: '+14',
        id: 375
    },
    {
        name: 'Pacific/Apia',
        displayName: 'GMT+13:00 Апиа +13/+14',
        nameLocalized: 'Апиа',
        abbreviationStandard: '+13/+14',
        id: 485
    },
    {
        name: 'Pacific/Tongatapu',
        displayName: 'GMT+13:00 Тонгатапу +13/+14',
        nameLocalized: 'Тонгатапу',
        abbreviationStandard: '+13/+14',
        id: 520,
        enabled: true
    },
    {
        name: 'Pacific/Fakaofo',
        displayName: 'GMT+13:00 Факаофо +13',
        nameLocalized: 'Факаофо',
        abbreviationStandard: '+13',
        id: 491
    },
    {
        name: 'Etc/GMT-13',
        displayName: 'GMT+13:00 GMT-13 +13',
        nameLocalized: 'GMT-13',
        abbreviationStandard: '+13',
        id: 374
    },
    {
        name: 'Pacific/Chatham',
        displayName: 'GMT+12:45 Чатем +1245/+1345',
        nameLocalized: 'Чатем',
        abbreviationStandard: '+1245/+1345',
        abbreviationDaylight: '+1245/+1345',
        id: 487
    },
    {
        name: 'Asia/Anadyr',
        displayName: 'GMT+12:00 Анадырь +12',
        nameLocalized: 'Анадырь',
        abbreviationStandard: '+12',
        id: 216
    },
    {
        name: 'Pacific/Kwajalein',
        displayName: 'GMT+12:00 Кваджалейн +12',
        nameLocalized: 'Кваджалейн',
        abbreviationStandard: '+12',
        id: 502
    },
    {
        name: 'Pacific/Majuro',
        displayName: 'GMT+12:00 Маджуро +12',
        nameLocalized: 'Маджуро',
        abbreviationStandard: '+12',
        id: 503
    },
    {
        name: 'Antarctica/McMurdo',
        displayName: 'GMT+12:00 Мак-Мердо NZST',
        nameLocalized: 'Мак-Мердо',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 206
    },
    {
        name: 'Pacific/Nauru',
        displayName: 'GMT+12:00 Науру +12',
        nameLocalized: 'Науру',
        abbreviationStandard: '+12',
        id: 506
    },
    {
        name: 'Pacific/Auckland',
        displayName: 'GMT+12:00 Окленд NZST',
        nameLocalized: 'Окленд',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 486,
        enabled: true
    },
    {
        name: 'Asia/Kamchatka',
        displayName: 'GMT+12:00 Петропавловск-Камчатский +12',
        nameLocalized: 'Петропавловск-Камчатский',
        abbreviationStandard: '+12',
        id: 249
    },
    {
        name: 'Pacific/Tarawa',
        displayName: 'GMT+12:00 Тарава +12',
        nameLocalized: 'Тарава',
        abbreviationStandard: '+12',
        id: 519
    },
    {
        name: 'Pacific/Wallis',
        displayName: 'GMT+12:00 Уоллис +12',
        nameLocalized: 'Уоллис',
        abbreviationStandard: '+12',
        id: 523
    },
    {
        name: 'Pacific/Wake',
        displayName: 'GMT+12:00 Уэйк +12',
        nameLocalized: 'Уэйк',
        abbreviationStandard: '+12',
        id: 522
    },
    {
        name: 'Pacific/Fiji',
        displayName: 'GMT+12:00 Фиджи +12/+13',
        nameLocalized: 'Фиджи',
        abbreviationStandard: '+12/+13',
        id: 492,
        enabled: true
    },
    {
        name: 'Pacific/Funafuti',
        displayName: 'GMT+12:00 Фунафути +12',
        nameLocalized: 'Фунафути',
        abbreviationStandard: '+12',
        id: 493
    },
    {
        name: 'Kwajalein',
        displayName: 'GMT+12:00 Kwajalein +12',
        nameLocalized: 'Kwajalein',
        abbreviationStandard: '+12',
        id: 474
    },
    {
        name: 'NZ',
        displayName: 'GMT+12:00 NZ NZST',
        nameLocalized: 'NZ',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 483
    },
    {
        name: 'Antarctica/South_Pole',
        displayName: 'GMT+12:00 South Pole NZST',
        nameLocalized: 'South Pole',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 209
    },
    {
        name: 'Pacific/Guadalcanal',
        displayName: 'GMT+11:00 Гуадалканал +11',
        nameLocalized: 'Гуадалканал',
        abbreviationStandard: '+11',
        id: 496
    },
    {
        name: 'Pacific/Kosrae',
        displayName: 'GMT+11:00 Косрае +11',
        nameLocalized: 'Косрае',
        abbreviationStandard: '+11',
        id: 501
    },
    {
        name: 'Asia/Magadan',
        displayName: 'GMT+11:00 Магадан +11',
        nameLocalized: 'Магадан',
        abbreviationStandard: '+11',
        id: 259,
        enabled: true
    },
    {
        name: 'Pacific/Norfolk',
        displayName: 'GMT+11:00 Норфолк +11/+12',
        nameLocalized: 'Норфолк',
        abbreviationStandard: '+11/+12',
        abbreviationDaylight: '+11/+12',
        id: 508
    },
    {
        name: 'Pacific/Noumea',
        displayName: 'GMT+11:00 Нумеа +11/+12',
        nameLocalized: 'Нумеа',
        abbreviationStandard: '+11/+12',
        id: 509
    },
    {
        name: 'Asia/Sakhalin',
        displayName: 'GMT+11:00 о-в Сахалин +11',
        nameLocalized: 'о-в Сахалин',
        abbreviationStandard: '+11',
        id: 275
    },
    {
        name: 'Pacific/Ponape',
        displayName: 'GMT+11:00 Понпеи +11',
        nameLocalized: 'Понпеи',
        abbreviationStandard: '+11',
        id: 513
    },
    {
        name: 'Pacific/Efate',
        displayName: 'GMT+11:00 Эфате +11/+12',
        nameLocalized: 'Эфате',
        abbreviationStandard: '+11/+12',
        id: 489
    },
    {
        name: 'Australia/Lord_Howe',
        displayName: 'GMT+10:30 Лорд-Хау +1030/+11',
        nameLocalized: 'Лорд-Хау',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 320
    },
    {
        name: 'Australia/LHI',
        displayName: 'GMT+10:30 LHI +1030/+11',
        nameLocalized: 'LHI',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 318
    },
    {
        name: 'Australia/Brisbane',
        displayName: 'GMT+10:00 Брисбен AEST',
        nameLocalized: 'Брисбен',
        abbreviationStandard: 'AEST',
        id: 311,
        enabled: true
    },
    {
        name: 'Asia/Vladivostok',
        displayName: 'GMT+10:00 Владивосток +10',
        nameLocalized: 'Владивосток',
        abbreviationStandard: '+10',
        id: 293,
        enabled: true
    },
    {
        name: 'Pacific/Guam',
        displayName: 'GMT+10:00 Гуам ChST',
        nameLocalized: 'Гуам',
        abbreviationStandard: 'ChST',
        id: 497,
        enabled: true
    },
    {
        name: 'Antarctica/DumontDUrville',
        displayName: 'GMT+10:00 Дюмон-д’Юрвиль +10',
        nameLocalized: 'Дюмон-д’Юрвиль',
        abbreviationStandard: '+10',
        id: 204
    },
    {
        name: 'Australia/Lindeman',
        displayName: 'GMT+10:00 Линдеман AEST',
        nameLocalized: 'Линдеман',
        abbreviationStandard: 'AEST',
        id: 319
    },
    {
        name: 'Australia/Melbourne',
        displayName: 'GMT+10:00 Мельбурн AEST',
        nameLocalized: 'Мельбурн',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 321
    },
    {
        name: 'Pacific/Port_Moresby',
        displayName: 'GMT+10:00 Порт-Морсби +10',
        nameLocalized: 'Порт-Морсби',
        abbreviationStandard: '+10',
        id: 514
    },
    {
        name: 'Pacific/Saipan',
        displayName: 'GMT+10:00 Сайпан ChST',
        nameLocalized: 'Сайпан',
        abbreviationStandard: 'ChST',
        id: 516
    },
    {
        name: 'Australia/Sydney',
        displayName: 'GMT+10:00 Сидней AEST',
        nameLocalized: 'Сидней',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 327,
        enabled: true
    },
    {
        name: 'Pacific/Truk',
        displayName: 'GMT+10:00 Трук +10',
        nameLocalized: 'Трук',
        abbreviationStandard: '+10',
        id: 521
    },
    {
        name: 'Australia/Hobart',
        displayName: 'GMT+10:00 Хобарт AEST',
        nameLocalized: 'Хобарт',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 317,
        enabled: true
    },
    {
        name: 'Australia/ACT',
        displayName: 'GMT+10:00 ACT AEST',
        nameLocalized: 'ACT',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 309
    },
    {
        name: 'Australia/Canberra',
        displayName: 'GMT+10:00 Canberra AEST',
        nameLocalized: 'Canberra',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 313
    },
    {
        name: 'Australia/Currie',
        displayName: 'GMT+10:00 Currie AEST',
        nameLocalized: 'Currie',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 314
    },
    {
        name: 'Australia/NSW',
        displayName: 'GMT+10:00 NSW AEST',
        nameLocalized: 'NSW',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 323
    },
    {
        name: 'Australia/Queensland',
        displayName: 'GMT+10:00 Queensland AEST',
        nameLocalized: 'Queensland',
        abbreviationStandard: 'AEST',
        id: 325
    },
    {
        name: 'Australia/Tasmania',
        displayName: 'GMT+10:00 Tasmania AEST',
        nameLocalized: 'Tasmania',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 328
    },
    {
        name: 'Australia/Victoria',
        displayName: 'GMT+10:00 Victoria AEST',
        nameLocalized: 'Victoria',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 329
    },
    {
        name: 'Pacific/Yap',
        displayName: 'GMT+10:00 Yap +10',
        nameLocalized: 'Yap',
        abbreviationStandard: '+10',
        id: 524
    },
    {
        name: 'Australia/Adelaide',
        displayName: 'GMT+09:30 Аделаида ACST',
        nameLocalized: 'Аделаида',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 310,
        enabled: true
    },
    {
        name: 'Australia/Broken_Hill',
        displayName: 'GMT+09:30 Брокен-Хилл ACST',
        nameLocalized: 'Брокен-Хилл',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 312
    },
    {
        name: 'Australia/Darwin',
        displayName: 'GMT+09:30 Дарвин ACST',
        nameLocalized: 'Дарвин',
        abbreviationStandard: 'ACST',
        id: 315,
        enabled: true
    },
    {
        name: 'Australia/North',
        displayName: 'GMT+09:30 North ACST',
        nameLocalized: 'North',
        abbreviationStandard: 'ACST',
        id: 322
    },
    {
        name: 'Australia/South',
        displayName: 'GMT+09:30 South ACST',
        nameLocalized: 'South',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 326
    },
    {
        name: 'Australia/Yancowinna',
        displayName: 'GMT+09:30 Yancowinna ACST',
        nameLocalized: 'Yancowinna',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 331
    },
    {
        name: 'Asia/Jayapura',
        displayName: 'GMT+09:00 Джаяпура WIT',
        nameLocalized: 'Джаяпура',
        abbreviationStandard: 'WIT',
        id: 246
    },
    {
        name: 'Asia/Dili',
        displayName: 'GMT+09:00 Дили +09',
        nameLocalized: 'Дили',
        abbreviationStandard: '+09',
        id: 236
    },
    {
        name: 'Pacific/Palau',
        displayName: 'GMT+09:00 Палау +09',
        nameLocalized: 'Палау',
        abbreviationStandard: '+09',
        id: 511
    },
    {
        name: 'Asia/Pyongyang',
        displayName: 'GMT+09:00 Пхеньян KST',
        nameLocalized: 'Пхеньян',
        abbreviationStandard: 'KST',
        id: 269
    },
    {
        name: 'Asia/Seoul',
        displayName: 'GMT+09:00 Сеул KST',
        nameLocalized: 'Сеул',
        abbreviationStandard: 'KST',
        id: 277,
        enabled: true
    },
    {
        name: 'Asia/Tokyo',
        displayName: 'GMT+09:00 Токио JST',
        nameLocalized: 'Токио',
        abbreviationStandard: 'JST',
        id: 287,
        enabled: true
    },
    {
        name: 'Asia/Yakutsk',
        displayName: 'GMT+09:00 Якутск +09',
        nameLocalized: 'Якутск',
        abbreviationStandard: '+09',
        id: 294,
        enabled: true
    },
    {
        name: 'Australia/Eucla',
        displayName: 'GMT+08:45 Юкла +0845/+0945',
        nameLocalized: 'Юкла',
        abbreviationStandard: '+0845/+0945',
        id: 316
    },
    {
        name: 'Asia/Brunei',
        displayName: 'GMT+08:00 Бруней +08',
        nameLocalized: 'Бруней',
        abbreviationStandard: '+08',
        id: 227
    },
    {
        name: 'Asia/Hong_Kong',
        displayName: 'GMT+08:00 Гонконг HKST',
        nameLocalized: 'Гонконг',
        abbreviationStandard: 'HKST',
        id: 241,
        enabled: true
    },
    {
        name: 'Asia/Irkutsk',
        displayName: 'GMT+08:00 Иркутск +08',
        nameLocalized: 'Иркутск',
        abbreviationStandard: '+08',
        id: 243
    },
    {
        name: 'Antarctica/Casey',
        displayName: 'GMT+08:00 Кейси +08',
        nameLocalized: 'Кейси',
        abbreviationStandard: '+08',
        id: 202
    },
    {
        name: 'Asia/Kuala_Lumpur',
        displayName: 'GMT+08:00 Куала-Лумпур +08',
        nameLocalized: 'Куала-Лумпур',
        abbreviationStandard: '+08',
        id: 254,
        enabled: true
    },
    {
        name: 'Asia/Kuching',
        displayName: 'GMT+08:00 Кучинг +08',
        nameLocalized: 'Кучинг',
        abbreviationStandard: '+08',
        id: 255
    },
    {
        name: 'Asia/Macau',
        displayName: 'GMT+08:00 Макао CST',
        nameLocalized: 'Макао',
        abbreviationStandard: 'CST',
        id: 258
    },
    {
        name: 'Asia/Makassar',
        displayName: 'GMT+08:00 Макасар WITA',
        nameLocalized: 'Макасар',
        abbreviationStandard: 'WITA',
        id: 260
    },
    {
        name: 'Asia/Manila',
        displayName: 'GMT+08:00 Манила PST',
        nameLocalized: 'Манила',
        abbreviationStandard: 'PST',
        id: 261
    },
    {
        name: 'Australia/Perth',
        displayName: 'GMT+08:00 Перт AWST',
        nameLocalized: 'Перт',
        abbreviationStandard: 'AWST',
        id: 324,
        enabled: true
    },
    {
        name: 'Asia/Singapore',
        displayName: 'GMT+08:00 Сингапур +08',
        nameLocalized: 'Сингапур',
        abbreviationStandard: '+08',
        id: 279
    },
    {
        name: 'Asia/Taipei',
        displayName: 'GMT+08:00 Тайбэй CST',
        nameLocalized: 'Тайбэй',
        abbreviationStandard: 'CST',
        id: 280,
        enabled: true
    },
    {
        name: 'Asia/Ulaanbaatar',
        displayName: 'GMT+08:00 Улан-Батор +08/+09',
        nameLocalized: 'Улан-Батор',
        abbreviationStandard: '+08/+09',
        id: 289,
        enabled: true
    },
    {
        name: 'Asia/Choibalsan',
        displayName: 'GMT+08:00 Чойбалсан +08/+09',
        nameLocalized: 'Чойбалсан',
        abbreviationStandard: '+08/+09',
        id: 229
    },
    {
        name: 'Asia/Shanghai',
        displayName: 'GMT+08:00 Шанхай CST',
        nameLocalized: 'Шанхай',
        abbreviationStandard: 'CST',
        id: 278,
        enabled: true
    },
    {
        name: 'Asia/Chongqing',
        displayName: 'GMT+08:00 Chongqing CST',
        nameLocalized: 'Chongqing',
        abbreviationStandard: 'CST',
        id: 230
    },
    {
        name: 'Asia/Chungking',
        displayName: 'GMT+08:00 Chungking CST',
        nameLocalized: 'Chungking',
        abbreviationStandard: 'CST',
        id: 231
    },
    {
        name: 'Asia/Harbin',
        displayName: 'GMT+08:00 Harbin CST',
        nameLocalized: 'Harbin',
        abbreviationStandard: 'CST',
        id: 240
    },
    {
        name: 'Asia/Kashgar',
        displayName: 'GMT+08:00 Kashgar CST',
        nameLocalized: 'Kashgar',
        abbreviationStandard: 'CST',
        id: 251
    },
    {
        name: 'Asia/Ulan_Bator',
        displayName: 'GMT+08:00 Ulan Bator +08/+09',
        nameLocalized: 'Ulan Bator',
        abbreviationStandard: '+08/+09',
        id: 290
    },
    {
        name: 'Asia/Bangkok',
        displayName: 'GMT+07:00 Бангкок +07',
        nameLocalized: 'Бангкок',
        abbreviationStandard: '+07',
        id: 224,
        enabled: true
    },
    {
        name: 'Asia/Vientiane',
        displayName: 'GMT+07:00 Вьентьян +07',
        nameLocalized: 'Вьентьян',
        abbreviationStandard: '+07',
        id: 292
    },
    {
        name: 'Antarctica/Davis',
        displayName: 'GMT+07:00 Дейвис +07',
        nameLocalized: 'Дейвис',
        abbreviationStandard: '+07',
        id: 203
    },
    {
        name: 'Asia/Jakarta',
        displayName: 'GMT+07:00 Джакарта WIB',
        nameLocalized: 'Джакарта',
        abbreviationStandard: 'WIB',
        id: 245
    },
    {
        name: 'Asia/Krasnoyarsk',
        displayName: 'GMT+07:00 Красноярск +07',
        nameLocalized: 'Красноярск',
        abbreviationStandard: '+07',
        id: 253,
        enabled: true
    },
    {
        name: 'Asia/Novosibirsk',
        displayName: 'GMT+07:00 Новосибирск +07',
        nameLocalized: 'Новосибирск',
        abbreviationStandard: '+07',
        id: 264
    },
    {
        name: 'Indian/Christmas',
        displayName: 'GMT+07:00 о-в Рождества +07',
        nameLocalized: 'о-в Рождества',
        abbreviationStandard: '+07',
        id: 461
    },
    {
        name: 'Asia/Phnom_Penh',
        displayName: 'GMT+07:00 Пномпень +07',
        nameLocalized: 'Пномпень',
        abbreviationStandard: '+07',
        id: 267
    },
    {
        name: 'Asia/Pontianak',
        displayName: 'GMT+07:00 Понтианак WIB',
        nameLocalized: 'Понтианак',
        abbreviationStandard: 'WIB',
        id: 268
    },
    {
        name: 'Asia/Hovd',
        displayName: 'GMT+07:00 Ховд +07/+08',
        nameLocalized: 'Ховд',
        abbreviationStandard: '+07/+08',
        id: 242
    },
    {
        name: 'Asia/Saigon',
        displayName: 'GMT+07:00 Хошимин +07',
        nameLocalized: 'Хошимин',
        abbreviationStandard: '+07',
        id: 274
    },
    {
        name: 'Indian/Cocos',
        displayName: 'GMT+06:30 Кокосовые о-ва +0630',
        nameLocalized: 'Кокосовые о-ва',
        abbreviationStandard: '+0630',
        id: 462
    },
    {
        name: 'Asia/Bishkek',
        displayName: 'GMT+06:00 Бишкек +06',
        nameLocalized: 'Бишкек',
        abbreviationStandard: '+06',
        id: 226
    },
    {
        name: 'Asia/Dhaka',
        displayName: 'GMT+06:00 Дакка +06/+07',
        nameLocalized: 'Дакка',
        abbreviationStandard: '+06/+07',
        id: 235,
        enabled: true
    },
    {
        name: 'Asia/Omsk',
        displayName: 'GMT+06:00 Омск +06',
        nameLocalized: 'Омск',
        abbreviationStandard: '+06',
        id: 265
    },
    {
        name: 'Asia/Thimphu',
        displayName: 'GMT+06:00 Тхимпху +06',
        nameLocalized: 'Тхимпху',
        abbreviationStandard: '+06',
        id: 286
    },
    {
        name: 'Asia/Urumqi',
        displayName: 'GMT+06:00 Урумчи +06',
        nameLocalized: 'Урумчи',
        abbreviationStandard: '+06',
        id: 291
    },
    {
        name: 'Indian/Chagos',
        displayName: 'GMT+06:00 Чагос +06',
        nameLocalized: 'Чагос',
        abbreviationStandard: '+06',
        id: 460
    },
    {
        name: 'Asia/Colombo',
        displayName: 'GMT+05:30 Коломбо +0530',
        nameLocalized: 'Коломбо',
        abbreviationStandard: '+0530',
        id: 232,
        enabled: true
    },
    {
        name: 'Asia/Aqtau',
        displayName: 'GMT+05:00 Актау +05',
        nameLocalized: 'Актау',
        abbreviationStandard: '+05',
        id: 217
    },
    {
        name: 'Asia/Aqtobe',
        displayName: 'GMT+05:00 Актобе +05',
        nameLocalized: 'Актобе',
        abbreviationStandard: '+05',
        id: 218
    },
    {
        name: 'Asia/Almaty',
        displayName: 'GMT+05:00 Алматы +05',
        nameLocalized: 'Алматы',
        abbreviationStandard: '+05',
        id: 214,
        enabled: true
    },
    {
        name: 'Asia/Ashgabat',
        displayName: 'GMT+05:00 Ашхабад +05',
        nameLocalized: 'Ашхабад',
        abbreviationStandard: '+05',
        id: 219
    },
    {
        name: 'Antarctica/Vostok',
        displayName: 'GMT+05:00 Восток +05',
        nameLocalized: 'Восток',
        abbreviationStandard: '+05',
        id: 211
    },
    {
        name: 'Asia/Dushanbe',
        displayName: 'GMT+05:00 Душанбе +05',
        nameLocalized: 'Душанбе',
        abbreviationStandard: '+05',
        id: 238
    },
    {
        name: 'Asia/Yekaterinburg',
        displayName: 'GMT+05:00 Екатеринбург +05',
        nameLocalized: 'Екатеринбург',
        abbreviationStandard: '+05',
        id: 295,
        enabled: true
    },
    {
        name: 'Asia/Karachi',
        displayName: 'GMT+05:00 Карачи PKST',
        nameLocalized: 'Карачи',
        abbreviationStandard: 'PKST',
        id: 250,
        enabled: true
    },
    {
        name: 'Indian/Kerguelen',
        displayName: 'GMT+05:00 Кергелен +05',
        nameLocalized: 'Кергелен',
        abbreviationStandard: '+05',
        id: 464
    },
    {
        name: 'Asia/Qyzylorda',
        displayName: 'GMT+05:00 Кызылорда +05',
        nameLocalized: 'Кызылорда',
        abbreviationStandard: '+05',
        id: 271
    },
    {
        name: 'Indian/Maldives',
        displayName: 'GMT+05:00 Мальдивы +05',
        nameLocalized: 'Мальдивы',
        abbreviationStandard: '+05',
        id: 466
    },
    {
        name: 'Antarctica/Mawson',
        displayName: 'GMT+05:00 Моусон +05',
        nameLocalized: 'Моусон',
        abbreviationStandard: '+05',
        id: 205
    },
    {
        name: 'Asia/Samarkand',
        displayName: 'GMT+05:00 Самарканд +05',
        nameLocalized: 'Самарканд',
        abbreviationStandard: '+05',
        id: 276
    },
    {
        name: 'Asia/Tashkent',
        displayName: 'GMT+05:00 Ташкент +05',
        nameLocalized: 'Ташкент',
        abbreviationStandard: '+05',
        id: 281
    },
    {
        name: 'Asia/Oral',
        displayName: 'GMT+05:00 Уральск +05',
        nameLocalized: 'Уральск',
        abbreviationStandard: '+05',
        id: 266
    },
    {
        name: 'Asia/Kabul',
        displayName: 'GMT+04:30 Кабул +0430',
        nameLocalized: 'Кабул',
        abbreviationStandard: '+0430',
        id: 248,
        enabled: true
    },
    {
        name: 'Asia/Baku',
        displayName: 'GMT+04:00 Баку +04/+05',
        nameLocalized: 'Баку',
        abbreviationStandard: '+04/+05',
        id: 223,
        enabled: true
    },
    {
        name: 'Asia/Dubai',
        displayName: 'GMT+04:00 Дубай +04',
        nameLocalized: 'Дубай',
        abbreviationStandard: '+04',
        id: 237
    },
    {
        name: 'Asia/Yerevan',
        displayName: 'GMT+04:00 Ереван +04/+05',
        nameLocalized: 'Ереван',
        abbreviationStandard: '+04/+05',
        id: 296,
        enabled: true
    },
    {
        name: 'Indian/Mauritius',
        displayName: 'GMT+04:00 Маврикий +04/+05',
        nameLocalized: 'Маврикий',
        abbreviationStandard: '+04/+05',
        id: 467
    },
    {
        name: 'Asia/Muscat',
        displayName: 'GMT+04:00 Маскат +04',
        nameLocalized: 'Маскат',
        abbreviationStandard: '+04',
        id: 262,
        enabled: true
    },
    {
        name: 'Indian/Mahe',
        displayName: 'GMT+04:00 Маэ +04',
        nameLocalized: 'Маэ',
        abbreviationStandard: '+04',
        id: 465
    },
    {
        name: 'Indian/Reunion',
        displayName: 'GMT+04:00 Реюньон +04',
        nameLocalized: 'Реюньон',
        abbreviationStandard: '+04',
        id: 469
    },
    {
        name: 'Europe/Samara',
        displayName: 'GMT+04:00 Самара +04',
        nameLocalized: 'Самара',
        abbreviationStandard: '+04',
        id: 428
    },
    {
        name: 'Asia/Tbilisi',
        displayName: 'GMT+04:00 Тбилиси +04',
        nameLocalized: 'Тбилиси',
        abbreviationStandard: '+04',
        id: 282,
        enabled: true
    },
    {
        name: 'Asia/Tehran',
        displayName: 'GMT+03:30 Тегеран +0330/+0430',
        nameLocalized: 'Тегеран',
        abbreviationStandard: '+0330/+0430',
        id: 283,
        enabled: true
    },
    {
        name: 'Africa/Addis_Ababa',
        displayName: 'GMT+03:00 Аддис-Абеба EAT',
        nameLocalized: 'Аддис-Абеба',
        abbreviationStandard: 'EAT',
        id: 3
    },
    {
        name: 'Asia/Aden',
        displayName: 'GMT+03:00 Аден +03',
        nameLocalized: 'Аден',
        abbreviationStandard: '+03',
        id: 213
    },
    {
        name: 'Asia/Amman',
        displayName: 'GMT+03:00 Амман +03',
        nameLocalized: 'Амман',
        abbreviationStandard: '+03',
        id: 215,
        enabled: true
    },
    {
        name: 'Indian/Antananarivo',
        displayName: 'GMT+03:00 Антананариву EAT',
        nameLocalized: 'Антананариву',
        abbreviationStandard: 'EAT',
        id: 459
    },
    {
        name: 'Africa/Asmera',
        displayName: 'GMT+03:00 Асмэра EAT',
        nameLocalized: 'Асмэра',
        abbreviationStandard: 'EAT',
        id: 6
    },
    {
        name: 'Asia/Baghdad',
        displayName: 'GMT+03:00 Багдад +03/+04',
        nameLocalized: 'Багдад',
        abbreviationStandard: '+03/+04',
        id: 221,
        enabled: true
    },
    {
        name: 'Asia/Bahrain',
        displayName: 'GMT+03:00 Бахрейн +03',
        nameLocalized: 'Бахрейн',
        abbreviationStandard: '+03',
        id: 222
    },
    {
        name: 'Europe/Volgograd',
        displayName: 'GMT+03:00 Волгоград MSK',
        nameLocalized: 'Волгоград',
        abbreviationStandard: 'MSK',
        id: 443
    },
    {
        name: 'Asia/Damascus',
        displayName: 'GMT+03:00 Дамаск +03',
        nameLocalized: 'Дамаск',
        abbreviationStandard: '+03',
        id: 234
    },
    {
        name: 'Africa/Dar_es_Salaam',
        displayName: 'GMT+03:00 Дар-эс-Салам EAT',
        nameLocalized: 'Дар-эс-Салам',
        abbreviationStandard: 'EAT',
        id: 19
    },
    {
        name: 'Africa/Djibouti',
        displayName: 'GMT+03:00 Джибути EAT',
        nameLocalized: 'Джибути',
        abbreviationStandard: 'EAT',
        id: 20
    },
    {
        name: 'Africa/Kampala',
        displayName: 'GMT+03:00 Кампала EAT',
        nameLocalized: 'Кампала',
        abbreviationStandard: 'EAT',
        id: 27
    },
    {
        name: 'Asia/Qatar',
        displayName: 'GMT+03:00 Катар +03',
        nameLocalized: 'Катар',
        abbreviationStandard: '+03',
        id: 270
    },
    {
        name: 'Indian/Comoro',
        displayName: 'GMT+03:00 Коморы EAT',
        nameLocalized: 'Коморы',
        abbreviationStandard: 'EAT',
        id: 463
    },
    {
        name: 'Asia/Kuwait',
        displayName: 'GMT+03:00 Кувейт +03',
        nameLocalized: 'Кувейт',
        abbreviationStandard: '+03',
        id: 256,
        enabled: true
    },
    {
        name: 'Indian/Mayotte',
        displayName: 'GMT+03:00 Майотта EAT',
        nameLocalized: 'Майотта',
        abbreviationStandard: 'EAT',
        id: 468
    },
    {
        name: 'Europe/Minsk',
        displayName: 'GMT+03:00 Минск +03',
        nameLocalized: 'Минск',
        abbreviationStandard: '+03',
        id: 418,
        enabled: true
    },
    {
        name: 'Africa/Mogadishu',
        displayName: 'GMT+03:00 Могадишо EAT',
        nameLocalized: 'Могадишо',
        abbreviationStandard: 'EAT',
        id: 41
    },
    {
        name: 'Europe/Moscow',
        displayName: 'GMT+03:00 Москва MSK',
        nameLocalized: 'Москва',
        abbreviationStandard: 'MSK',
        id: 420,
        enabled: true
    },
    {
        name: 'Africa/Nairobi',
        displayName: 'GMT+03:00 Найроби EAT',
        nameLocalized: 'Найроби',
        abbreviationStandard: 'EAT',
        id: 43,
        enabled: true
    },
    {
        name: 'Antarctica/Syowa',
        displayName: 'GMT+03:00 Сёва +03',
        nameLocalized: 'Сёва',
        abbreviationStandard: '+03',
        id: 210
    },
    {
        name: 'Europe/Simferopol',
        displayName: 'GMT+03:00 Симферополь MSK',
        nameLocalized: 'Симферополь',
        abbreviationStandard: 'MSK',
        id: 431
    },
    {
        name: 'Europe/Istanbul',
        displayName: 'GMT+03:00 Стамбул +03',
        nameLocalized: 'Стамбул',
        abbreviationStandard: '+03',
        id: 244,
        enabled: true
    },
    {
        name: 'Asia/Riyadh',
        displayName: 'GMT+03:00 Эр-Рияд +03',
        nameLocalized: 'Эр-Рияд',
        abbreviationStandard: '+03',
        id: 273
    },
    {
        name: 'Africa/Asmara',
        displayName: 'GMT+03:00 Asmara EAT',
        nameLocalized: 'Asmara',
        abbreviationStandard: 'EAT',
        id: 5
    },
    {
        name: 'Asia/Istanbul',
        displayName: 'GMT+03:00 Istanbul +03',
        nameLocalized: 'Istanbul',
        abbreviationStandard: '+03',
        id: 407
    },
    {
        name: 'Europe/Tiraspol',
        displayName: 'GMT+03:00 Tiraspol MSK/MSD',
        nameLocalized: 'Tiraspol',
        abbreviationStandard: 'MSK/MSD',
        id: 437
    },
    {
        name: 'Europe/Athens',
        displayName: 'GMT+02:00 Афины EET',
        nameLocalized: 'Афины',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 392
    },
    {
        name: 'Asia/Beirut',
        displayName: 'GMT+02:00 Бейрут EET',
        nameLocalized: 'Бейрут',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 225,
        enabled: true
    },
    {
        name: 'Africa/Blantyre',
        displayName: 'GMT+02:00 Блантайр CAT',
        nameLocalized: 'Блантайр',
        abbreviationStandard: 'CAT',
        id: 11
    },
    {
        name: 'Africa/Bujumbura',
        displayName: 'GMT+02:00 Бужумбура CAT',
        nameLocalized: 'Бужумбура',
        abbreviationStandard: 'CAT',
        id: 13
    },
    {
        name: 'Europe/Bucharest',
        displayName: 'GMT+02:00 Бухарест EET',
        nameLocalized: 'Бухарест',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 398
    },
    {
        name: 'Europe/Vilnius',
        displayName: 'GMT+02:00 Вильнюс EET',
        nameLocalized: 'Вильнюс',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 442
    },
    {
        name: 'Africa/Windhoek',
        displayName: 'GMT+02:00 Виндхук WAT',
        nameLocalized: 'Виндхук',
        abbreviationStandard: 'WAT',
        id: 53,
        enabled: true
    },
    {
        name: 'Africa/Gaborone',
        displayName: 'GMT+02:00 Габороне CAT',
        nameLocalized: 'Габороне',
        abbreviationStandard: 'CAT',
        id: 24
    },
    {
        name: 'Asia/Gaza',
        displayName: 'GMT+02:00 Газа EET',
        nameLocalized: 'Газа',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 239
    },
    {
        name: 'Asia/Jerusalem',
        displayName: 'GMT+02:00 Иерусалим IST',
        nameLocalized: 'Иерусалим',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 247,
        enabled: true
    },
    {
        name: 'Africa/Johannesburg',
        displayName: 'GMT+02:00 Йоханнесбург SAST',
        nameLocalized: 'Йоханнесбург',
        abbreviationStandard: 'SAST',
        id: 26
    },
    {
        name: 'Africa/Cairo',
        displayName: 'GMT+02:00 Каир EET',
        nameLocalized: 'Каир',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 14,
        enabled: true
    },
    {
        name: 'Europe/Kaliningrad',
        displayName: 'GMT+02:00 Калининград EET',
        nameLocalized: 'Калининград',
        abbreviationStandard: 'EET',
        id: 409
    },
    {
        name: 'Africa/Kigali',
        displayName: 'GMT+02:00 Кигали CAT',
        nameLocalized: 'Кигали',
        abbreviationStandard: 'CAT',
        id: 29
    },
    {
        name: 'Europe/Kiev',
        displayName: 'GMT+02:00 Киев EET',
        nameLocalized: 'Киев',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 410
    },
    {
        name: 'Europe/Chisinau',
        displayName: 'GMT+02:00 Кишинев EET',
        nameLocalized: 'Кишинев',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 400
    },
    {
        name: 'Africa/Lubumbashi',
        displayName: 'GMT+02:00 Лубумбаши CAT',
        nameLocalized: 'Лубумбаши',
        abbreviationStandard: 'CAT',
        id: 35
    },
    {
        name: 'Africa/Lusaka',
        displayName: 'GMT+02:00 Лусака CAT',
        nameLocalized: 'Лусака',
        abbreviationStandard: 'CAT',
        id: 36
    },
    {
        name: 'Africa/Maputo',
        displayName: 'GMT+02:00 Мапуту CAT',
        nameLocalized: 'Мапуту',
        abbreviationStandard: 'CAT',
        id: 38
    },
    {
        name: 'Europe/Mariehamn',
        displayName: 'GMT+02:00 Мариехамн EET',
        nameLocalized: 'Мариехамн',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 417
    },
    {
        name: 'Africa/Maseru',
        displayName: 'GMT+02:00 Масеру SAST',
        nameLocalized: 'Масеру',
        abbreviationStandard: 'SAST',
        id: 39
    },
    {
        name: 'Africa/Mbabane',
        displayName: 'GMT+02:00 Мбабане SAST',
        nameLocalized: 'Мбабане',
        abbreviationStandard: 'SAST',
        id: 40
    },
    {
        name: 'Asia/Nicosia',
        displayName: 'GMT+02:00 Никосия EET',
        nameLocalized: 'Никосия',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 263
    },
    {
        name: 'Europe/Riga',
        displayName: 'GMT+02:00 Рига EET',
        nameLocalized: 'Рига',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 426
    },
    {
        name: 'Europe/Sofia',
        displayName: 'GMT+02:00 София EET',
        nameLocalized: 'София',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 433
    },
    {
        name: 'Europe/Tallinn',
        displayName: 'GMT+02:00 Таллин EET',
        nameLocalized: 'Таллин',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 435
    },
    {
        name: 'Africa/Tripoli',
        displayName: 'GMT+02:00 Триполи EET',
        nameLocalized: 'Триполи',
        abbreviationStandard: 'EET',
        id: 51
    },
    {
        name: 'Africa/Harare',
        displayName: 'GMT+02:00 Хараре CAT',
        nameLocalized: 'Хараре',
        abbreviationStandard: 'CAT',
        id: 25,
        enabled: true
    },
    {
        name: 'Africa/Khartoum',
        displayName: 'GMT+02:00 Хартум CAT',
        nameLocalized: 'Хартум',
        abbreviationStandard: 'CAT',
        id: 28
    },
    {
        name: 'Europe/Helsinki',
        displayName: 'GMT+02:00 Хельсинки EET',
        nameLocalized: 'Хельсинки',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 405,
        enabled: true
    },
    {
        name: 'EET',
        displayName: 'GMT+02:00 EET EET',
        nameLocalized: 'EET',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 350
    },
    {
        name: 'Europe/Nicosia',
        displayName: 'GMT+02:00 Nicosia EET',
        nameLocalized: 'Nicosia',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 421
    },
    {
        name: 'Asia/Tel_Aviv',
        displayName: 'GMT+02:00 Tel Aviv IST',
        nameLocalized: 'Tel Aviv',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 284
    },
    {
        name: 'Europe/Uzhgorod',
        displayName: 'GMT+02:00 Uzhgorod EET',
        nameLocalized: 'Uzhgorod',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 438
    },
    {
        name: 'Europe/Zaporozhye',
        displayName: 'GMT+02:00 Zaporozhye EET',
        nameLocalized: 'Zaporozhye',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 446
    },
    {
        name: 'Africa/Algiers',
        displayName: 'GMT+01:00 Алжир CET',
        nameLocalized: 'Алжир',
        abbreviationStandard: 'CET',
        id: 4
    },
    {
        name: 'Europe/Amsterdam',
        displayName: 'GMT+01:00 Амстердам CET',
        nameLocalized: 'Амстердам',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 390,
        enabled: true
    },
    {
        name: 'Europe/Andorra',
        displayName: 'GMT+01:00 Андорра CET',
        nameLocalized: 'Андорра',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 391
    },
    {
        name: 'Africa/Bangui',
        displayName: 'GMT+01:00 Банги WAT',
        nameLocalized: 'Банги',
        abbreviationStandard: 'WAT',
        id: 8
    },
    {
        name: 'Europe/Belgrade',
        displayName: 'GMT+01:00 Белград CET',
        nameLocalized: 'Белград',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 394
    },
    {
        name: 'Europe/Berlin',
        displayName: 'GMT+01:00 Берлин CET',
        nameLocalized: 'Берлин',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 395
    },
    {
        name: 'Africa/Brazzaville',
        displayName: 'GMT+01:00 Браззавиль WAT',
        nameLocalized: 'Браззавиль',
        abbreviationStandard: 'WAT',
        id: 12
    },
    {
        name: 'Europe/Bratislava',
        displayName: 'GMT+01:00 Братислава CET',
        nameLocalized: 'Братислава',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 396
    },
    {
        name: 'Europe/Brussels',
        displayName: 'GMT+01:00 Брюссель CET',
        nameLocalized: 'Брюссель',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 397
    },
    {
        name: 'Europe/Budapest',
        displayName: 'GMT+01:00 Будапешт CET',
        nameLocalized: 'Будапешт',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 399,
        enabled: true
    },
    {
        name: 'Europe/Vaduz',
        displayName: 'GMT+01:00 Вадуц CET',
        nameLocalized: 'Вадуц',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 439
    },
    {
        name: 'Europe/Warsaw',
        displayName: 'GMT+01:00 Варшава CET',
        nameLocalized: 'Варшава',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 444
    },
    {
        name: 'Europe/Vatican',
        displayName: 'GMT+01:00 Ватикан CET',
        nameLocalized: 'Ватикан',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 440
    },
    {
        name: 'Europe/Vienna',
        displayName: 'GMT+01:00 Вена CET',
        nameLocalized: 'Вена',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 441
    },
    {
        name: 'Europe/Gibraltar',
        displayName: 'GMT+01:00 Гибралтар CET',
        nameLocalized: 'Гибралтар',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 403
    },
    {
        name: 'Africa/Douala',
        displayName: 'GMT+01:00 Дуала WAT',
        nameLocalized: 'Дуала',
        abbreviationStandard: 'WAT',
        id: 21
    },
    {
        name: 'Europe/Dublin',
        displayName: 'GMT+01:00 Дублин IST/GMT',
        nameLocalized: 'Дублин',
        abbreviationStandard: 'IST/GMT',
        id: 402
    },
    {
        name: 'Europe/Zagreb',
        displayName: 'GMT+01:00 Загреб CET',
        nameLocalized: 'Загреб',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 445
    },
    {
        name: 'Africa/Casablanca',
        displayName: 'GMT+01:00 Касабланка +01/+00',
        nameLocalized: 'Касабланка',
        abbreviationStandard: '+01/+00',
        id: 15,
        enabled: true
    },
    {
        name: 'Africa/Kinshasa',
        displayName: 'GMT+01:00 Киншаса WAT',
        nameLocalized: 'Киншаса',
        abbreviationStandard: 'WAT',
        id: 30
    },
    {
        name: 'Europe/Copenhagen',
        displayName: 'GMT+01:00 Копенгаген CET',
        nameLocalized: 'Копенгаген',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 401
    },
    {
        name: 'Africa/Lagos',
        displayName: 'GMT+01:00 Лагос WAT',
        nameLocalized: 'Лагос',
        abbreviationStandard: 'WAT',
        id: 31
    },
    {
        name: 'Africa/Libreville',
        displayName: 'GMT+01:00 Либревиль WAT',
        nameLocalized: 'Либревиль',
        abbreviationStandard: 'WAT',
        id: 32
    },
    {
        name: 'Arctic/Longyearbyen',
        displayName: 'GMT+01:00 Лонгйир CET',
        nameLocalized: 'Лонгйир',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 212
    },
    {
        name: 'Africa/Luanda',
        displayName: 'GMT+01:00 Луанда WAT',
        nameLocalized: 'Луанда',
        abbreviationStandard: 'WAT',
        id: 34
    },
    {
        name: 'Europe/Ljubljana',
        displayName: 'GMT+01:00 Любляна CET',
        nameLocalized: 'Любляна',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 412
    },
    {
        name: 'Europe/Luxembourg',
        displayName: 'GMT+01:00 Люксембург CET',
        nameLocalized: 'Люксембург',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 414
    },
    {
        name: 'Europe/Madrid',
        displayName: 'GMT+01:00 Мадрид CET',
        nameLocalized: 'Мадрид',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 415,
        enabled: true
    },
    {
        name: 'Africa/Malabo',
        displayName: 'GMT+01:00 Малабо WAT',
        nameLocalized: 'Малабо',
        abbreviationStandard: 'WAT',
        id: 37
    },
    {
        name: 'Europe/Malta',
        displayName: 'GMT+01:00 Мальта CET',
        nameLocalized: 'Мальта',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 416
    },
    {
        name: 'Europe/Monaco',
        displayName: 'GMT+01:00 Монако CET',
        nameLocalized: 'Монако',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 419
    },
    {
        name: 'Africa/Ndjamena',
        displayName: 'GMT+01:00 Нджамена WAT',
        nameLocalized: 'Нджамена',
        abbreviationStandard: 'WAT',
        id: 44
    },
    {
        name: 'Africa/Niamey',
        displayName: 'GMT+01:00 Ниамей WAT',
        nameLocalized: 'Ниамей',
        abbreviationStandard: 'WAT',
        id: 45
    },
    {
        name: 'Europe/Oslo',
        displayName: 'GMT+01:00 Осло CET',
        nameLocalized: 'Осло',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 422
    },
    {
        name: 'Europe/Paris',
        displayName: 'GMT+01:00 Париж CET',
        nameLocalized: 'Париж',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 423
    },
    {
        name: 'Europe/Podgorica',
        displayName: 'GMT+01:00 Подгорица CET',
        nameLocalized: 'Подгорица',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 424
    },
    {
        name: 'Africa/Porto-Novo',
        displayName: 'GMT+01:00 Порто-Ново WAT',
        nameLocalized: 'Порто-Ново',
        abbreviationStandard: 'WAT',
        id: 48,
        enabled: true
    },
    {
        name: 'Europe/Prague',
        displayName: 'GMT+01:00 Прага CET',
        nameLocalized: 'Прага',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 425
    },
    {
        name: 'Europe/Rome',
        displayName: 'GMT+01:00 Рим CET',
        nameLocalized: 'Рим',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 427
    },
    {
        name: 'Europe/San_Marino',
        displayName: 'GMT+01:00 Сан-Марино CET',
        nameLocalized: 'Сан-Марино',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 429
    },
    {
        name: 'Europe/Sarajevo',
        displayName: 'GMT+01:00 Сараево CET',
        nameLocalized: 'Сараево',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 430,
        enabled: true
    },
    {
        name: 'Africa/Ceuta',
        displayName: 'GMT+01:00 Сеута CET',
        nameLocalized: 'Сеута',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 16
    },
    {
        name: 'Europe/Skopje',
        displayName: 'GMT+01:00 Скопье CET',
        nameLocalized: 'Скопье',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 432
    },
    {
        name: 'Europe/Stockholm',
        displayName: 'GMT+01:00 Стокгольм CET',
        nameLocalized: 'Стокгольм',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 434
    },
    {
        name: 'Europe/Tirane',
        displayName: 'GMT+01:00 Тирана CET',
        nameLocalized: 'Тирана',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 436
    },
    {
        name: 'Africa/Tunis',
        displayName: 'GMT+01:00 Тунис CEST',
        nameLocalized: 'Тунис',
        abbreviationStandard: 'CEST',
        id: 52
    },
    {
        name: 'Europe/Zurich',
        displayName: 'GMT+01:00 Цюрих CET',
        nameLocalized: 'Цюрих',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 447
    },
    {
        name: 'Africa/El_Aaiun',
        displayName: 'GMT+01:00 Эль-Аюн +01/+00',
        nameLocalized: 'Эль-Аюн',
        abbreviationStandard: '+01/+00',
        id: 22
    },
    {
        name: 'CET',
        displayName: 'GMT+01:00 CET CET',
        nameLocalized: 'CET',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 345
    },
    {
        name: 'MET',
        displayName: 'GMT+01:00 MET MET',
        nameLocalized: 'MET',
        abbreviationStandard: 'MET',
        abbreviationDaylight: 'MEST',
        id: 476
    },
    {
        name: 'Africa/Abidjan',
        displayName: 'GMT+00:00 Абиджан GMT',
        nameLocalized: 'Абиджан',
        abbreviationStandard: 'GMT',
        id: 1
    },
    {
        name: 'Africa/Accra',
        displayName: 'GMT+00:00 Аккра GMT',
        nameLocalized: 'Аккра',
        abbreviationStandard: 'GMT',
        id: 2
    },
    {
        name: 'Africa/Bamako',
        displayName: 'GMT+00:00 Бамако GMT',
        nameLocalized: 'Бамако',
        abbreviationStandard: 'GMT',
        id: 7
    },
    {
        name: 'Africa/Banjul',
        displayName: 'GMT+00:00 Банжул GMT',
        nameLocalized: 'Банжул',
        abbreviationStandard: 'GMT',
        id: 9
    },
    {
        name: 'Africa/Bissau',
        displayName: 'GMT+00:00 Бисау GMT',
        nameLocalized: 'Бисау',
        abbreviationStandard: 'GMT',
        id: 10
    },
    {
        name: 'Europe/Guernsey',
        displayName: 'GMT+00:00 Гернси GMT/BST',
        nameLocalized: 'Гернси',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 404
    },
    {
        name: 'Africa/Dakar',
        displayName: 'GMT+00:00 Дакар GMT',
        nameLocalized: 'Дакар',
        abbreviationStandard: 'GMT',
        id: 18
    },
    {
        name: 'America/Danmarkshavn',
        displayName: 'GMT+00:00 Денмарксхавн GMT',
        nameLocalized: 'Денмарксхавн',
        abbreviationStandard: 'GMT',
        id: 97
    },
    {
        name: 'Europe/Jersey',
        displayName: 'GMT+00:00 Джерси GMT/BST',
        nameLocalized: 'Джерси',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 408
    },
    {
        name: 'Asia/Calcutta',
        displayName: 'GMT+00:00 Калькутта UTC',
        nameLocalized: 'Калькутта',
        abbreviationStandard: 'UTC',
        id: 228,
        enabled: true
    },
    {
        name: 'Atlantic/Canary',
        displayName: 'GMT+00:00 Канарские о-ва WET',
        nameLocalized: 'Канарские о-ва',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 299
    },
    {
        name: 'Asia/Katmandu',
        displayName: 'GMT+00:00 Катманду UTC',
        nameLocalized: 'Катманду',
        abbreviationStandard: 'UTC',
        id: 252,
        enabled: true
    },
    {
        name: 'Africa/Conakry',
        displayName: 'GMT+00:00 Конакри GMT',
        nameLocalized: 'Конакри',
        abbreviationStandard: 'GMT',
        id: 17
    },
    {
        name: 'Europe/Lisbon',
        displayName: 'GMT+00:00 Лиссабон WET',
        nameLocalized: 'Лиссабон',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 411
    },
    {
        name: 'Africa/Lome',
        displayName: 'GMT+00:00 Ломе GMT',
        nameLocalized: 'Ломе',
        abbreviationStandard: 'GMT',
        id: 33
    },
    {
        name: 'Europe/London',
        displayName: 'GMT+00:00 Лондон GMT/BST',
        nameLocalized: 'Лондон',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 413,
        enabled: true
    },
    {
        name: 'Atlantic/Madeira',
        displayName: 'GMT+00:00 Мадейра WET',
        nameLocalized: 'Мадейра',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 304
    },
    {
        name: 'Africa/Monrovia',
        displayName: 'GMT+00:00 Монровия GMT',
        nameLocalized: 'Монровия',
        abbreviationStandard: 'GMT',
        id: 42
    },
    {
        name: 'Africa/Nouakchott',
        displayName: 'GMT+00:00 Нуакшот GMT',
        nameLocalized: 'Нуакшот',
        abbreviationStandard: 'GMT',
        id: 46
    },
    {
        name: 'Europe/Isle_of_Man',
        displayName: 'GMT+00:00 о-в Мэн GMT/BST',
        nameLocalized: 'о-в Мэн',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 406
    },
    {
        name: 'Atlantic/St_Helena',
        displayName: 'GMT+00:00 о-в Святой Елены GMT',
        nameLocalized: 'о-в Святой Елены',
        abbreviationStandard: 'GMT',
        id: 307
    },
    {
        name: 'Pacific/Enderbury',
        displayName: 'GMT+00:00 о-в Эндербери -00',
        nameLocalized: 'о-в Эндербери',
        abbreviationStandard: '-00',
        id: 490
    },
    {
        name: 'Atlantic/Reykjavik',
        displayName: 'GMT+00:00 Рейкьявик GMT',
        nameLocalized: 'Рейкьявик',
        abbreviationStandard: 'GMT',
        id: 305
    },
    {
        name: 'Africa/Sao_Tome',
        displayName: 'GMT+00:00 Сан-Томе GMT',
        nameLocalized: 'Сан-Томе',
        abbreviationStandard: 'GMT',
        id: 49
    },
    {
        name: 'Africa/Ouagadougou',
        displayName: 'GMT+00:00 Уагадугу GMT',
        nameLocalized: 'Уагадугу',
        abbreviationStandard: 'GMT',
        id: 47
    },
    {
        name: 'Atlantic/Faeroe',
        displayName: 'GMT+00:00 Фарерские о-ва UTC',
        nameLocalized: 'Фарерские о-ва',
        abbreviationStandard: 'UTC',
        id: 301
    },
    {
        name: 'Africa/Freetown',
        displayName: 'GMT+00:00 Фритаун GMT',
        nameLocalized: 'Фритаун',
        abbreviationStandard: 'GMT',
        id: 23
    },
    {
        name: 'Asia/Rangoon',
        displayName: 'GMT+00:00 Янгон UTC',
        nameLocalized: 'Янгон',
        abbreviationStandard: 'UTC',
        id: 272,
        enabled: true
    },
    {
        name: 'US/Aleutian',
        displayName: 'GMT+00:00 Aleutian UTC',
        nameLocalized: 'Aleutian',
        abbreviationStandard: 'UTC',
        id: 536
    },
    {
        name: 'US/Arizona',
        displayName: 'GMT+00:00 Arizona UTC',
        nameLocalized: 'Arizona',
        abbreviationStandard: 'UTC',
        id: 537
    },
    {
        name: 'Asia/Ashkhabad',
        displayName: 'GMT+00:00 Ashkhabad UTC',
        nameLocalized: 'Ashkhabad',
        abbreviationStandard: 'UTC',
        id: 220
    },
    {
        name: 'America/Atka',
        displayName: 'GMT+00:00 Atka UTC',
        nameLocalized: 'Atka',
        abbreviationStandard: 'UTC',
        id: 73
    },
    {
        name: 'Canada/Atlantic',
        displayName: 'GMT+00:00 Atlantic UTC',
        nameLocalized: 'Atlantic',
        abbreviationStandard: 'UTC',
        id: 336
    },
    {
        name: 'Mexico/BajaNorte',
        displayName: 'GMT+00:00 BajaNorte UTC',
        nameLocalized: 'BajaNorte',
        abbreviationStandard: 'UTC',
        id: 477
    },
    {
        name: 'Europe/Belfast',
        displayName: 'GMT+00:00 Belfast GMT/BST',
        nameLocalized: 'Belfast',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 393
    },
    {
        name: 'US/Central',
        displayName: 'GMT+00:00 Central UTC',
        nameLocalized: 'Central',
        abbreviationStandard: 'UTC',
        id: 538
    },
    {
        name: 'Cuba',
        displayName: 'GMT+00:00 Cuba UTC',
        nameLocalized: 'Cuba',
        abbreviationStandard: 'UTC',
        id: 349
    },
    {
        name: 'Asia/Dacca',
        displayName: 'GMT+00:00 Dacca UTC',
        nameLocalized: 'Dacca',
        abbreviationStandard: 'UTC',
        id: 233
    },
    {
        name: 'Brazil/DeNoronha',
        displayName: 'GMT+00:00 DeNoronha UTC',
        nameLocalized: 'DeNoronha',
        abbreviationStandard: 'UTC',
        id: 333
    },
    {
        name: 'Canada/East-Saskatchewan',
        displayName: 'GMT+00:00 East-Saskatchewan UTC',
        nameLocalized: 'East-Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 338
    },
    {
        name: 'Chile/EasterIsland',
        displayName: 'GMT+00:00 EasterIsland UTC',
        nameLocalized: 'EasterIsland',
        abbreviationStandard: 'UTC',
        id: 347
    },
    {
        name: 'Canada/Eastern',
        displayName: 'GMT+00:00 Eastern UTC',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'UTC',
        id: 339
    },
    {
        name: 'Egypt',
        displayName: 'GMT+00:00 Egypt UTC',
        nameLocalized: 'Egypt',
        abbreviationStandard: 'UTC',
        id: 351
    },
    {
        name: 'Eire',
        displayName: 'GMT+00:00 Eire UTC',
        nameLocalized: 'Eire',
        abbreviationStandard: 'UTC',
        id: 352
    },
    {
        name: 'Factory',
        displayName: 'GMT+00:00 Factory -00',
        nameLocalized: 'Factory',
        abbreviationStandard: '-00',
        id: 448
    },
    {
        name: 'Atlantic/Faroe',
        displayName: 'GMT+00:00 Faroe WET',
        nameLocalized: 'Faroe',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 302
    },
    {
        name: 'GB',
        displayName: 'GMT+00:00 GB UTC',
        nameLocalized: 'GB',
        abbreviationStandard: 'UTC',
        id: 449
    },
    {
        name: 'GB-Eire',
        displayName: 'GMT+00:00 GB-Eire UTC',
        nameLocalized: 'GB-Eire',
        abbreviationStandard: 'UTC',
        id: 450
    },
    {
        name: 'Etc/GMT',
        displayName: 'GMT+00:00 GMT GMT',
        nameLocalized: 'GMT',
        abbreviationStandard: 'GMT',
        id: 355
    },
    {
        name: 'GMT',
        displayName: 'GMT+00:00 GMT UTC',
        nameLocalized: 'GMT',
        abbreviationStandard: 'UTC',
        id: 451
    },
    {
        name: 'Etc/GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 369
    },
    {
        name: 'GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 453
    },
    {
        name: 'Etc/GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 356
    },
    {
        name: 'GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 452
    },
    {
        name: 'Etc/GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 384
    },
    {
        name: 'GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 454
    },
    {
        name: 'Etc/Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 385
    },
    {
        name: 'Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 455
    },
    {
        name: 'Hongkong',
        displayName: 'GMT+00:00 Hongkong UTC',
        nameLocalized: 'Hongkong',
        abbreviationStandard: 'UTC',
        id: 456
    },
    {
        name: 'Iceland',
        displayName: 'GMT+00:00 Iceland GMT',
        nameLocalized: 'Iceland',
        abbreviationStandard: 'GMT',
        id: 458
    },
    {
        name: 'Iran',
        displayName: 'GMT+00:00 Iran UTC',
        nameLocalized: 'Iran',
        abbreviationStandard: 'UTC',
        id: 470
    },
    {
        name: 'Israel',
        displayName: 'GMT+00:00 Israel UTC',
        nameLocalized: 'Israel',
        abbreviationStandard: 'UTC',
        id: 471
    },
    {
        name: 'Jamaica',
        displayName: 'GMT+00:00 Jamaica UTC',
        nameLocalized: 'Jamaica',
        abbreviationStandard: 'UTC',
        id: 472
    },
    {
        name: 'Japan',
        displayName: 'GMT+00:00 Japan UTC',
        nameLocalized: 'Japan',
        abbreviationStandard: 'UTC',
        id: 473
    },
    {
        name: 'Libya',
        displayName: 'GMT+00:00 Libya UTC',
        nameLocalized: 'Libya',
        abbreviationStandard: 'UTC',
        id: 475
    },
    {
        name: 'Asia/Macao',
        displayName: 'GMT+00:00 Macao UTC',
        nameLocalized: 'Macao',
        abbreviationStandard: 'UTC',
        id: 257
    },
    {
        name: 'US/Michigan',
        displayName: 'GMT+00:00 Michigan UTC',
        nameLocalized: 'Michigan',
        abbreviationStandard: 'UTC',
        id: 543
    },
    {
        name: 'US/Mountain',
        displayName: 'GMT+00:00 Mountain UTC',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'UTC',
        id: 544
    },
    {
        name: 'Navajo',
        displayName: 'GMT+00:00 Navajo UTC',
        nameLocalized: 'Navajo',
        abbreviationStandard: 'UTC',
        id: 482
    },
    {
        name: 'NZ-CHAT',
        displayName: 'GMT+00:00 NZ-CHAT UTC',
        nameLocalized: 'NZ-CHAT',
        abbreviationStandard: 'UTC',
        id: 484
    },
    {
        name: 'US/Pacific-New',
        displayName: 'GMT+00:00 Pacific-New UTC',
        nameLocalized: 'Pacific-New',
        abbreviationStandard: 'UTC',
        id: 546
    },
    {
        name: 'Poland',
        displayName: 'GMT+00:00 Poland UTC',
        nameLocalized: 'Poland',
        abbreviationStandard: 'UTC',
        id: 525
    },
    {
        name: 'Portugal',
        displayName: 'GMT+00:00 Portugal UTC',
        nameLocalized: 'Portugal',
        abbreviationStandard: 'UTC',
        id: 526
    },
    {
        name: 'PRC',
        displayName: 'GMT+00:00 PRC UTC',
        nameLocalized: 'PRC',
        abbreviationStandard: 'UTC',
        id: 527
    },
    {
        name: 'ROC',
        displayName: 'GMT+00:00 ROC UTC',
        nameLocalized: 'ROC',
        abbreviationStandard: 'UTC',
        id: 529
    },
    {
        name: 'ROK',
        displayName: 'GMT+00:00 ROK UTC',
        nameLocalized: 'ROK',
        abbreviationStandard: 'UTC',
        id: 530
    },
    {
        name: 'Canada/Saskatchewan',
        displayName: 'GMT+00:00 Saskatchewan UTC',
        nameLocalized: 'Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 343,
        enabled: true
    },
    {
        name: 'America/Shiprock',
        displayName: 'GMT+00:00 Shiprock UTC',
        nameLocalized: 'Shiprock',
        abbreviationStandard: 'UTC',
        id: 183
    },
    {
        name: 'Singapore',
        displayName: 'GMT+00:00 Singapore UTC',
        nameLocalized: 'Singapore',
        abbreviationStandard: 'UTC',
        id: 531
    },
    {
        name: 'Asia/Thimbu',
        displayName: 'GMT+00:00 Thimbu UTC',
        nameLocalized: 'Thimbu',
        abbreviationStandard: 'UTC',
        id: 285
    },
    {
        name: 'Africa/Timbuktu',
        displayName: 'GMT+00:00 Timbuktu GMT',
        nameLocalized: 'Timbuktu',
        abbreviationStandard: 'GMT',
        id: 50
    },
    {
        name: 'Turkey',
        displayName: 'GMT+00:00 Turkey UTC',
        nameLocalized: 'Turkey',
        abbreviationStandard: 'UTC',
        id: 532
    },
    {
        name: 'Etc/UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 386
    },
    {
        name: 'UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 533
    },
    {
        name: 'Asia/Ujung_Pandang',
        displayName: 'GMT+00:00 Ujung Pandang UTC',
        nameLocalized: 'Ujung Pandang',
        abbreviationStandard: 'UTC',
        id: 288
    },
    {
        name: 'Etc/Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 387
    },
    {
        name: 'Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 534
    },
    {
        name: 'Etc/UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 388
    },
    {
        name: 'UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 548
    },
    {
        name: 'W-SU',
        displayName: 'GMT+00:00 W-SU UTC',
        nameLocalized: 'W-SU',
        abbreviationStandard: 'UTC',
        id: 549
    },
    {
        name: 'Australia/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 330
    },
    {
        name: 'Brazil/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 335
    },
    {
        name: 'WET',
        displayName: 'GMT+00:00 WET WET',
        nameLocalized: 'WET',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 550
    },
    {
        name: 'Etc/Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 389
    },
    {
        name: 'Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 551,
        enabled: true
    },
    {
        name: 'Atlantic/Azores',
        displayName: 'GMT-01:00 Азорские о-ва -01/+00',
        nameLocalized: 'Азорские о-ва',
        abbreviationStandard: '-01/+00',
        abbreviationDaylight: '-01/+00',
        id: 297,
        enabled: true
    },
    {
        name: 'Atlantic/Cape_Verde',
        displayName: 'GMT-01:00 Кабо-Верде -01',
        nameLocalized: 'Кабо-Верде',
        abbreviationStandard: '-01',
        id: 300,
        enabled: true
    },
    {
        name: 'Etc/GMT-1',
        displayName: 'GMT-01:00 GMT-1 -01',
        nameLocalized: 'GMT-1',
        abbreviationStandard: '-01',
        id: 370
    },
    {
        name: 'Etc/GMT+1',
        displayName: 'GMT-01:00 GMT+1 -01',
        nameLocalized: 'GMT+1',
        abbreviationStandard: '-01',
        id: 357
    },
    {
        name: 'Atlantic/Jan_Mayen',
        displayName: 'GMT-01:00 Jan Mayen -01',
        nameLocalized: 'Jan Mayen',
        abbreviationStandard: '-01',
        id: 303
    },
    {
        name: 'America/Noronha',
        displayName: 'GMT-02:00 Норонья -02',
        nameLocalized: 'Норонья',
        abbreviationStandard: '-02',
        id: 160
    },
    {
        name: 'America/Scoresbysund',
        displayName: 'GMT-02:00 Скорсбисунн -02/-01',
        nameLocalized: 'Скорсбисунн',
        abbreviationStandard: '-02/-01',
        abbreviationDaylight: '-02/-01',
        id: 182
    },
    {
        name: 'Atlantic/South_Georgia',
        displayName: 'GMT-02:00 Южная Георгия -02',
        nameLocalized: 'Южная Георгия',
        abbreviationStandard: '-02',
        id: 306,
        enabled: true
    },
    {
        name: 'Etc/GMT-2',
        displayName: 'GMT-02:00 GMT-2 -02',
        nameLocalized: 'GMT-2',
        abbreviationStandard: '-02',
        id: 376
    },
    {
        name: 'Etc/GMT+2',
        displayName: 'GMT-02:00 GMT+2 -02',
        nameLocalized: 'GMT+2',
        abbreviationStandard: '-02',
        id: 361
    },
    {
        name: 'America/St_Johns',
        displayName: 'GMT-03:30 Сент-Джонс NST',
        nameLocalized: 'Сент-Джонс',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 184,
        enabled: true
    },
    {
        name: 'Canada/Newfoundland',
        displayName: 'GMT-03:30 Newfoundland NST',
        nameLocalized: 'Newfoundland',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 341
    },
    {
        name: 'America/Araguaina',
        displayName: 'GMT-03:00 Арагуаина -03',
        nameLocalized: 'Арагуаина',
        abbreviationStandard: '-03',
        id: 58
    },
    {
        name: 'America/Bahia',
        displayName: 'GMT-03:00 Баия -03',
        nameLocalized: 'Баия',
        abbreviationStandard: '-03',
        id: 74
    },
    {
        name: 'America/Belem',
        displayName: 'GMT-03:00 Белен -03',
        nameLocalized: 'Белен',
        abbreviationStandard: '-03',
        id: 76
    },
    {
        name: 'America/Buenos_Aires',
        displayName: 'GMT-03:00 Буэнос-Айрес -03/-02',
        nameLocalized: 'Буэнос-Айрес',
        abbreviationStandard: '-03/-02',
        id: 82,
        enabled: true
    },
    {
        name: 'America/Jujuy',
        displayName: 'GMT-03:00 Жужуй -03',
        nameLocalized: 'Жужуй',
        abbreviationStandard: '-03',
        id: 132
    },
    {
        name: 'America/Cayenne',
        displayName: 'GMT-03:00 Кайенна -03',
        nameLocalized: 'Кайенна',
        abbreviationStandard: '-03',
        id: 88
    },
    {
        name: 'America/Catamarca',
        displayName: 'GMT-03:00 Катамарка -03',
        nameLocalized: 'Катамарка',
        abbreviationStandard: '-03',
        id: 87
    },
    {
        name: 'America/Cordoba',
        displayName: 'GMT-03:00 Кордова -03/-02',
        nameLocalized: 'Кордова',
        abbreviationStandard: '-03/-02',
        id: 93
    },
    {
        name: 'America/Argentina/La_Rioja',
        displayName: 'GMT-03:00 Ла-Риоха -03',
        nameLocalized: 'Ла-Риоха',
        abbreviationStandard: '-03',
        id: 64
    },
    {
        name: 'America/Maceio',
        displayName: 'GMT-03:00 Масейо -03',
        nameLocalized: 'Масейо',
        abbreviationStandard: '-03',
        id: 141
    },
    {
        name: 'America/Mendoza',
        displayName: 'GMT-03:00 Мендоса -03',
        nameLocalized: 'Мендоса',
        abbreviationStandard: '-03',
        id: 146
    },
    {
        name: 'America/Miquelon',
        displayName: 'GMT-03:00 Микелон -03/-02',
        nameLocalized: 'Микелон',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 150
    },
    {
        name: 'America/Montevideo',
        displayName: 'GMT-03:00 Монтевидео -03/-02',
        nameLocalized: 'Монтевидео',
        abbreviationStandard: '-03/-02',
        id: 153,
        enabled: true
    },
    {
        name: 'America/Godthab',
        displayName: 'GMT-03:00 Нуук -03/-02',
        nameLocalized: 'Нуук',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 110,
        enabled: true
    },
    {
        name: 'Antarctica/Palmer',
        displayName: 'GMT-03:00 Палмер -03',
        nameLocalized: 'Палмер',
        abbreviationStandard: '-03',
        id: 207
    },
    {
        name: 'America/Paramaribo',
        displayName: 'GMT-03:00 Парамарибо -03',
        nameLocalized: 'Парамарибо',
        abbreviationStandard: '-03',
        id: 165
    },
    {
        name: 'America/Recife',
        displayName: 'GMT-03:00 Ресифи -03',
        nameLocalized: 'Ресифи',
        abbreviationStandard: '-03',
        id: 174
    },
    {
        name: 'America/Argentina/Rio_Gallegos',
        displayName: 'GMT-03:00 Рио-Гальегос -03',
        nameLocalized: 'Рио-Гальегос',
        abbreviationStandard: '-03',
        id: 66
    },
    {
        name: 'Antarctica/Rothera',
        displayName: 'GMT-03:00 Ротера -03',
        nameLocalized: 'Ротера',
        abbreviationStandard: '-03',
        id: 208
    },
    {
        name: 'America/Sao_Paulo',
        displayName: 'GMT-03:00 Сан-Паулу -03/-02',
        nameLocalized: 'Сан-Паулу',
        abbreviationStandard: '-03/-02',
        id: 181,
        enabled: true
    },
    {
        name: 'America/Argentina/San_Juan',
        displayName: 'GMT-03:00 Сан-Хуан -03',
        nameLocalized: 'Сан-Хуан',
        abbreviationStandard: '-03',
        id: 67
    },
    {
        name: 'Atlantic/Stanley',
        displayName: 'GMT-03:00 Стэнли -03',
        nameLocalized: 'Стэнли',
        abbreviationStandard: '-03',
        id: 308
    },
    {
        name: 'America/Argentina/Tucuman',
        displayName: 'GMT-03:00 Тукуман -03/-02',
        nameLocalized: 'Тукуман',
        abbreviationStandard: '-03/-02',
        id: 68
    },
    {
        name: 'America/Argentina/Ushuaia',
        displayName: 'GMT-03:00 Ушуая -03',
        nameLocalized: 'Ушуая',
        abbreviationStandard: '-03',
        id: 69
    },
    {
        name: 'America/Fortaleza',
        displayName: 'GMT-03:00 Форталеза -03',
        nameLocalized: 'Форталеза',
        abbreviationStandard: '-03',
        id: 108
    },
    {
        name: 'America/Argentina/Buenos_Aires',
        displayName: 'GMT-03:00 Buenos Aires -03/-02',
        nameLocalized: 'Buenos Aires',
        abbreviationStandard: '-03/-02',
        id: 59
    },
    {
        name: 'America/Argentina/Catamarca',
        displayName: 'GMT-03:00 Catamarca -03',
        nameLocalized: 'Catamarca',
        abbreviationStandard: '-03',
        id: 60
    },
    {
        name: 'America/Argentina/ComodRivadavia',
        displayName: 'GMT-03:00 ComodRivadavia -03',
        nameLocalized: 'ComodRivadavia',
        abbreviationStandard: '-03',
        id: 61
    },
    {
        name: 'America/Argentina/Cordoba',
        displayName: 'GMT-03:00 Cordoba -03/-02',
        nameLocalized: 'Cordoba',
        abbreviationStandard: '-03/-02',
        id: 62
    },
    {
        name: 'Brazil/East',
        displayName: 'GMT-03:00 East -03/-02',
        nameLocalized: 'East',
        abbreviationStandard: '-03/-02',
        id: 334
    },
    {
        name: 'Etc/GMT-3',
        displayName: 'GMT-03:00 GMT-3 -03',
        nameLocalized: 'GMT-3',
        abbreviationStandard: '-03',
        id: 377
    },
    {
        name: 'Etc/GMT+3',
        displayName: 'GMT-03:00 GMT+3 -03',
        nameLocalized: 'GMT+3',
        abbreviationStandard: '-03',
        id: 362
    },
    {
        name: 'America/Argentina/Jujuy',
        displayName: 'GMT-03:00 Jujuy -03',
        nameLocalized: 'Jujuy',
        abbreviationStandard: '-03',
        id: 63
    },
    {
        name: 'America/Argentina/Mendoza',
        displayName: 'GMT-03:00 Mendoza -03',
        nameLocalized: 'Mendoza',
        abbreviationStandard: '-03',
        id: 65
    },
    {
        name: 'America/Rosario',
        displayName: 'GMT-03:00 Rosario -03/-02',
        nameLocalized: 'Rosario',
        abbreviationStandard: '-03/-02',
        id: 178
    },
    {
        name: 'America/Anguilla',
        displayName: 'GMT-04:00 Ангилья AST',
        nameLocalized: 'Ангилья',
        abbreviationStandard: 'AST',
        id: 56
    },
    {
        name: 'America/Antigua',
        displayName: 'GMT-04:00 Антигуа AST',
        nameLocalized: 'Антигуа',
        abbreviationStandard: 'AST',
        id: 57
    },
    {
        name: 'America/Aruba',
        displayName: 'GMT-04:00 Аруба AST',
        nameLocalized: 'Аруба',
        abbreviationStandard: 'AST',
        id: 70
    },
    {
        name: 'America/Asuncion',
        displayName: 'GMT-04:00 Асунсьон -04/-03',
        nameLocalized: 'Асунсьон',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 71
    },
    {
        name: 'America/Barbados',
        displayName: 'GMT-04:00 Барбадос AST',
        nameLocalized: 'Барбадос',
        abbreviationStandard: 'AST',
        id: 75
    },
    {
        name: 'Atlantic/Bermuda',
        displayName: 'GMT-04:00 Бермудские о-ва AST',
        nameLocalized: 'Бермудские о-ва',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 298
    },
    {
        name: 'America/Blanc-Sablon',
        displayName: 'GMT-04:00 Бланк-Саблон AST',
        nameLocalized: 'Бланк-Саблон',
        abbreviationStandard: 'AST',
        id: 78
    },
    {
        name: 'America/Boa_Vista',
        displayName: 'GMT-04:00 Боа-Виста -04',
        nameLocalized: 'Боа-Виста',
        abbreviationStandard: '-04',
        id: 79
    },
    {
        name: 'America/Guyana',
        displayName: 'GMT-04:00 Гайана -04',
        nameLocalized: 'Гайана',
        abbreviationStandard: '-04',
        id: 117
    },
    {
        name: 'America/Halifax',
        displayName: 'GMT-04:00 Галифакс AST',
        nameLocalized: 'Галифакс',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 118
    },
    {
        name: 'America/Guadeloupe',
        displayName: 'GMT-04:00 Гваделупа AST',
        nameLocalized: 'Гваделупа',
        abbreviationStandard: 'AST',
        id: 114
    },
    {
        name: 'America/Glace_Bay',
        displayName: 'GMT-04:00 Глейс-Бей AST',
        nameLocalized: 'Глейс-Бей',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 109
    },
    {
        name: 'America/Grenada',
        displayName: 'GMT-04:00 Гренада AST',
        nameLocalized: 'Гренада',
        abbreviationStandard: 'AST',
        id: 113
    },
    {
        name: 'America/Goose_Bay',
        displayName: 'GMT-04:00 Гус-Бей AST',
        nameLocalized: 'Гус-Бей',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 111,
        enabled: true
    },
    {
        name: 'America/Dominica',
        displayName: 'GMT-04:00 Доминика AST',
        nameLocalized: 'Доминика',
        abbreviationStandard: 'AST',
        id: 102
    },
    {
        name: 'America/Campo_Grande',
        displayName: 'GMT-04:00 Кампу-Гранди -04/-03',
        nameLocalized: 'Кампу-Гранди',
        abbreviationStandard: '-04/-03',
        id: 84
    },
    {
        name: 'America/Caracas',
        displayName: 'GMT-04:00 Каракас -04',
        nameLocalized: 'Каракас',
        abbreviationStandard: '-04',
        id: 86,
        enabled: true
    },
    {
        name: 'America/Cuiaba',
        displayName: 'GMT-04:00 Куяба -04/-03',
        nameLocalized: 'Куяба',
        abbreviationStandard: '-04/-03',
        id: 95
    },
    {
        name: 'America/Curacao',
        displayName: 'GMT-04:00 Кюрасао AST',
        nameLocalized: 'Кюрасао',
        abbreviationStandard: 'AST',
        id: 96
    },
    {
        name: 'America/La_Paz',
        displayName: 'GMT-04:00 Ла-Пас -04',
        nameLocalized: 'Ла-Пас',
        abbreviationStandard: '-04',
        id: 137,
        enabled: true
    },
    {
        name: 'America/Manaus',
        displayName: 'GMT-04:00 Манаус -04',
        nameLocalized: 'Манаус',
        abbreviationStandard: '-04',
        id: 143,
        enabled: true
    },
    {
        name: 'America/Martinique',
        displayName: 'GMT-04:00 Мартиника AST',
        nameLocalized: 'Мартиника',
        abbreviationStandard: 'AST',
        id: 144
    },
    {
        name: 'America/Moncton',
        displayName: 'GMT-04:00 Монктон AST',
        nameLocalized: 'Монктон',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 151
    },
    {
        name: 'America/Montserrat',
        displayName: 'GMT-04:00 Монтсеррат AST',
        nameLocalized: 'Монтсеррат',
        abbreviationStandard: 'AST',
        id: 155
    },
    {
        name: 'America/Port_of_Spain',
        displayName: 'GMT-04:00 Порт-оф-Спейн AST',
        nameLocalized: 'Порт-оф-Спейн',
        abbreviationStandard: 'AST',
        id: 168
    },
    {
        name: 'America/Porto_Velho',
        displayName: 'GMT-04:00 Порту-Велью -04',
        nameLocalized: 'Порту-Велью',
        abbreviationStandard: '-04',
        id: 170
    },
    {
        name: 'America/Puerto_Rico',
        displayName: 'GMT-04:00 Пуэрто-Рико AST',
        nameLocalized: 'Пуэрто-Рико',
        abbreviationStandard: 'AST',
        id: 171
    },
    {
        name: 'America/Santo_Domingo',
        displayName: 'GMT-04:00 Санто-Доминго AST',
        nameLocalized: 'Санто-Доминго',
        abbreviationStandard: 'AST',
        id: 180
    },
    {
        name: 'America/Santiago',
        displayName: 'GMT-04:00 Сантьяго -04/-03',
        nameLocalized: 'Сантьяго',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 179,
        enabled: true
    },
    {
        name: 'America/St_Vincent',
        displayName: 'GMT-04:00 Сент-Винсент AST',
        nameLocalized: 'Сент-Винсент',
        abbreviationStandard: 'AST',
        id: 188
    },
    {
        name: 'America/St_Kitts',
        displayName: 'GMT-04:00 Сент-Китс AST',
        nameLocalized: 'Сент-Китс',
        abbreviationStandard: 'AST',
        id: 185
    },
    {
        name: 'America/St_Lucia',
        displayName: 'GMT-04:00 Сент-Люсия AST',
        nameLocalized: 'Сент-Люсия',
        abbreviationStandard: 'AST',
        id: 186
    },
    {
        name: 'America/St_Thomas',
        displayName: 'GMT-04:00 Сент-Томас AST',
        nameLocalized: 'Сент-Томас',
        abbreviationStandard: 'AST',
        id: 187
    },
    {
        name: 'America/Tortola',
        displayName: 'GMT-04:00 Тортола AST',
        nameLocalized: 'Тортола',
        abbreviationStandard: 'AST',
        id: 195
    },
    {
        name: 'America/Thule',
        displayName: 'GMT-04:00 Туле AST',
        nameLocalized: 'Туле',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 191
    },
    {
        name: 'Chile/Continental',
        displayName: 'GMT-04:00 Continental -04/-03',
        nameLocalized: 'Continental',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 346
    },
    {
        name: 'Etc/GMT-4',
        displayName: 'GMT-04:00 GMT-4 -04',
        nameLocalized: 'GMT-4',
        abbreviationStandard: '-04',
        id: 378
    },
    {
        name: 'Etc/GMT+4',
        displayName: 'GMT-04:00 GMT+4 -04',
        nameLocalized: 'GMT+4',
        abbreviationStandard: '-04',
        id: 363
    },
    {
        name: 'America/Virgin',
        displayName: 'GMT-04:00 Virgin AST',
        nameLocalized: 'Virgin',
        abbreviationStandard: 'AST',
        id: 197
    },
    {
        name: 'America/Bogota',
        displayName: 'GMT-05:00 Богота -05/-04',
        nameLocalized: 'Богота',
        abbreviationStandard: '-05/-04',
        id: 80,
        enabled: true
    },
    {
        name: 'America/Indiana/Vevay',
        displayName: 'GMT-05:00 Вевей, Индиана EST',
        nameLocalized: 'Вевей, Индиана',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 125
    },
    {
        name: 'America/Indiana/Vincennes',
        displayName: 'GMT-05:00 Винсеннес EST',
        nameLocalized: 'Винсеннес',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 126
    },
    {
        name: 'America/Havana',
        displayName: 'GMT-05:00 Гавана CST',
        nameLocalized: 'Гавана',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 119
    },
    {
        name: 'America/Grand_Turk',
        displayName: 'GMT-05:00 Гранд-Терк EST',
        nameLocalized: 'Гранд-Терк',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 112
    },
    {
        name: 'America/Guayaquil',
        displayName: 'GMT-05:00 Гуаякиль -05/-04',
        nameLocalized: 'Гуаякиль',
        abbreviationStandard: '-05/-04',
        id: 116
    },
    {
        name: 'America/Detroit',
        displayName: 'GMT-05:00 Детройт EST',
        nameLocalized: 'Детройт',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 101
    },
    {
        name: 'America/Iqaluit',
        displayName: 'GMT-05:00 Икалуит EST',
        nameLocalized: 'Икалуит',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 130
    },
    {
        name: 'America/Indianapolis',
        displayName: 'GMT-05:00 Индианаполис EST',
        nameLocalized: 'Индианаполис',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 128
    },
    {
        name: 'America/Cancun',
        displayName: 'GMT-05:00 Канкун EST',
        nameLocalized: 'Канкун',
        abbreviationStandard: 'EST',
        id: 85
    },
    {
        name: 'America/Coral_Harbour',
        displayName: 'GMT-05:00 Корал-Харбор EST',
        nameLocalized: 'Корал-Харбор',
        abbreviationStandard: 'EST',
        id: 92
    },
    {
        name: 'America/Lima',
        displayName: 'GMT-05:00 Лима -05/-04',
        nameLocalized: 'Лима',
        abbreviationStandard: '-05/-04',
        id: 138
    },
    {
        name: 'America/Louisville',
        displayName: 'GMT-05:00 Луисвилл EST',
        nameLocalized: 'Луисвилл',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 140
    },
    {
        name: 'America/Indiana/Marengo',
        displayName: 'GMT-05:00 Маренго, Индиана EST',
        nameLocalized: 'Маренго, Индиана',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 123
    },
    {
        name: 'America/Kentucky/Monticello',
        displayName: 'GMT-05:00 Монтиселло, Кентукки EST',
        nameLocalized: 'Монтиселло, Кентукки',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 135
    },
    {
        name: 'America/Nassau',
        displayName: 'GMT-05:00 Нассау EST',
        nameLocalized: 'Нассау',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 156
    },
    {
        name: 'America/New_York',
        displayName: 'GMT-05:00 Нью-Йорк EST',
        nameLocalized: 'Нью-Йорк',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 157,
        enabled: true
    },
    {
        name: 'America/Cayman',
        displayName: 'GMT-05:00 Острова Кайман EST',
        nameLocalized: 'Острова Кайман',
        abbreviationStandard: 'EST',
        id: 89
    },
    {
        name: 'America/Panama',
        displayName: 'GMT-05:00 Панама EST',
        nameLocalized: 'Панама',
        abbreviationStandard: 'EST',
        id: 163
    },
    {
        name: 'America/Indiana/Petersburg',
        displayName: 'GMT-05:00 Питерсберг, Индиана EST',
        nameLocalized: 'Питерсберг, Индиана',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 124
    },
    {
        name: 'America/Port-au-Prince',
        displayName: 'GMT-05:00 Порт-о-Пренс EST',
        nameLocalized: 'Порт-о-Пренс',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 167
    },
    {
        name: 'America/Rio_Branco',
        displayName: 'GMT-05:00 Риу-Бранку -05',
        nameLocalized: 'Риу-Бранку',
        abbreviationStandard: '-05',
        id: 177
    },
    {
        name: 'America/Toronto',
        displayName: 'GMT-05:00 Торонто EST',
        nameLocalized: 'Торонто',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 194
    },
    {
        name: 'America/Indiana/Winamac',
        displayName: 'GMT-05:00 Уинамак EST',
        nameLocalized: 'Уинамак',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 127
    },
    {
        name: 'America/Eirunepe',
        displayName: 'GMT-05:00 Эйрунепе -05',
        nameLocalized: 'Эйрунепе',
        abbreviationStandard: '-05',
        id: 104
    },
    {
        name: 'America/Jamaica',
        displayName: 'GMT-05:00 Ямайка EST',
        nameLocalized: 'Ямайка',
        abbreviationStandard: 'EST',
        id: 131
    },
    {
        name: 'Brazil/Acre',
        displayName: 'GMT-05:00 Acre -05',
        nameLocalized: 'Acre',
        abbreviationStandard: '-05',
        id: 332
    },
    {
        name: 'America/Atikokan',
        displayName: 'GMT-05:00 Atikokan EST',
        nameLocalized: 'Atikokan',
        abbreviationStandard: 'EST',
        id: 72
    },
    {
        name: 'US/East-Indiana',
        displayName: 'GMT-05:00 East-Indiana EST',
        nameLocalized: 'East-Indiana',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 539
    },
    {
        name: 'US/Eastern',
        displayName: 'GMT-05:00 Eastern EST',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 540
    },
    {
        name: 'EST',
        displayName: 'GMT-05:00 EST EST',
        nameLocalized: 'EST',
        abbreviationStandard: 'EST',
        id: 353
    },
    {
        name: 'EST5EDT',
        displayName: 'GMT-05:00 EST5EDT EST',
        nameLocalized: 'EST5EDT',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 354
    },
    {
        name: 'America/Fort_Wayne',
        displayName: 'GMT-05:00 Fort Wayne EST',
        nameLocalized: 'Fort Wayne',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 107
    },
    {
        name: 'Etc/GMT-5',
        displayName: 'GMT-05:00 GMT-5 -05',
        nameLocalized: 'GMT-5',
        abbreviationStandard: '-05',
        id: 379
    },
    {
        name: 'Etc/GMT+5',
        displayName: 'GMT-05:00 GMT+5 -05',
        nameLocalized: 'GMT+5',
        abbreviationStandard: '-05',
        id: 364
    },
    {
        name: 'America/Indiana/Indianapolis',
        displayName: 'GMT-05:00 Indianapolis EST',
        nameLocalized: 'Indianapolis',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 121
    },
    {
        name: 'America/Kentucky/Louisville',
        displayName: 'GMT-05:00 Louisville EST',
        nameLocalized: 'Louisville',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 134
    },
    {
        name: 'America/Montreal',
        displayName: 'GMT-05:00 Montreal EST',
        nameLocalized: 'Montreal',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 154
    },
    {
        name: 'America/Nipigon',
        displayName: 'GMT-05:00 Nipigon EST',
        nameLocalized: 'Nipigon',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 158
    },
    {
        name: 'America/Pangnirtung',
        displayName: 'GMT-05:00 Pangnirtung EST',
        nameLocalized: 'Pangnirtung',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 164
    },
    {
        name: 'America/Porto_Acre',
        displayName: 'GMT-05:00 Porto Acre -05',
        nameLocalized: 'Porto Acre',
        abbreviationStandard: '-05',
        id: 169
    },
    {
        name: 'America/Thunder_Bay',
        displayName: 'GMT-05:00 Thunder Bay EST',
        nameLocalized: 'Thunder Bay',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 192
    },
    {
        name: 'America/Belize',
        displayName: 'GMT-06:00 Белиз CST',
        nameLocalized: 'Белиз',
        abbreviationStandard: 'CST',
        id: 77
    },
    {
        name: 'America/Winnipeg',
        displayName: 'GMT-06:00 Виннипег CST',
        nameLocalized: 'Виннипег',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 199
    },
    {
        name: 'Pacific/Galapagos',
        displayName: 'GMT-06:00 Галапагосские о-ва -06/-05',
        nameLocalized: 'Галапагосские о-ва',
        abbreviationStandard: '-06/-05',
        id: 494
    },
    {
        name: 'America/Guatemala',
        displayName: 'GMT-06:00 Гватемала CST',
        nameLocalized: 'Гватемала',
        abbreviationStandard: 'CST',
        id: 115,
        enabled: true
    },
    {
        name: 'America/Costa_Rica',
        displayName: 'GMT-06:00 Коста-Рика CST',
        nameLocalized: 'Коста-Рика',
        abbreviationStandard: 'CST',
        id: 94
    },
    {
        name: 'America/Managua',
        displayName: 'GMT-06:00 Манагуа CST',
        nameLocalized: 'Манагуа',
        abbreviationStandard: 'CST',
        id: 142
    },
    {
        name: 'America/Menominee',
        displayName: 'GMT-06:00 Меномини CST',
        nameLocalized: 'Меномини',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 147
    },
    {
        name: 'America/Merida',
        displayName: 'GMT-06:00 Мерида CST',
        nameLocalized: 'Мерида',
        abbreviationStandard: 'CST',
        id: 148
    },
    {
        name: 'America/Mexico_City',
        displayName: 'GMT-06:00 Мехико CST',
        nameLocalized: 'Мехико',
        abbreviationStandard: 'CST',
        id: 149,
        enabled: true
    },
    {
        name: 'America/Monterrey',
        displayName: 'GMT-06:00 Монтеррей CST',
        nameLocalized: 'Монтеррей',
        abbreviationStandard: 'CST',
        id: 152
    },
    {
        name: 'America/Indiana/Knox',
        displayName: 'GMT-06:00 Нокс, Индиана CST',
        nameLocalized: 'Нокс, Индиана',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 122
    },
    {
        name: 'America/North_Dakota/New_Salem',
        displayName: 'GMT-06:00 Нью-Сейлем, Северная Дакота CST',
        nameLocalized: 'Нью-Сейлем, Северная Дакота',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 162
    },
    {
        name: 'Pacific/Easter',
        displayName: 'GMT-06:00 о-в Пасхи -06/-05',
        nameLocalized: 'о-в Пасхи',
        abbreviationStandard: '-06/-05',
        abbreviationDaylight: '-06/-05',
        id: 488
    },
    {
        name: 'America/Rankin_Inlet',
        displayName: 'GMT-06:00 Ранкин-Инлет CST',
        nameLocalized: 'Ранкин-Инлет',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 173
    },
    {
        name: 'America/Regina',
        displayName: 'GMT-06:00 Реджайна CST',
        nameLocalized: 'Реджайна',
        abbreviationStandard: 'CST',
        id: 175
    },
    {
        name: 'America/Resolute',
        displayName: 'GMT-06:00 Резольют CST',
        nameLocalized: 'Резольют',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 176
    },
    {
        name: 'America/El_Salvador',
        displayName: 'GMT-06:00 Сальвадор CST',
        nameLocalized: 'Сальвадор',
        abbreviationStandard: 'CST',
        id: 105
    },
    {
        name: 'America/Swift_Current',
        displayName: 'GMT-06:00 Свифт-Керрент CST',
        nameLocalized: 'Свифт-Керрент',
        abbreviationStandard: 'CST',
        id: 189
    },
    {
        name: 'America/Tegucigalpa',
        displayName: 'GMT-06:00 Тегусигальпа CST',
        nameLocalized: 'Тегусигальпа',
        abbreviationStandard: 'CST',
        id: 190
    },
    {
        name: 'America/North_Dakota/Center',
        displayName: 'GMT-06:00 Центр, Северная Дакота CST',
        nameLocalized: 'Центр, Северная Дакота',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 161
    },
    {
        name: 'America/Chicago',
        displayName: 'GMT-06:00 Чикаго CST',
        nameLocalized: 'Чикаго',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 90,
        enabled: true
    },
    {
        name: 'America/Chihuahua',
        displayName: 'GMT-06:00 Чиуауа CST',
        nameLocalized: 'Чиуауа',
        abbreviationStandard: 'CST',
        id: 91,
        enabled: true
    },
    {
        name: 'Canada/Central',
        displayName: 'GMT-06:00 Central CST',
        nameLocalized: 'Central',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 337
    },
    {
        name: 'CST6CDT',
        displayName: 'GMT-06:00 CST6CDT CST',
        nameLocalized: 'CST6CDT',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 348
    },
    {
        name: 'Mexico/General',
        displayName: 'GMT-06:00 General CST',
        nameLocalized: 'General',
        abbreviationStandard: 'CST',
        id: 479
    },
    {
        name: 'Etc/GMT-6',
        displayName: 'GMT-06:00 GMT-6 -06',
        nameLocalized: 'GMT-6',
        abbreviationStandard: '-06',
        id: 380
    },
    {
        name: 'Etc/GMT+6',
        displayName: 'GMT-06:00 GMT+6 -06',
        nameLocalized: 'GMT+6',
        abbreviationStandard: '-06',
        id: 365
    },
    {
        name: 'US/Indiana-Starke',
        displayName: 'GMT-06:00 Indiana-Starke CST',
        nameLocalized: 'Indiana-Starke',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 542
    },
    {
        name: 'America/Knox_IN',
        displayName: 'GMT-06:00 Knox IN CST',
        nameLocalized: 'Knox IN',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 136
    },
    {
        name: 'America/Rainy_River',
        displayName: 'GMT-06:00 Rainy River CST',
        nameLocalized: 'Rainy River',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 172
    },
    {
        name: 'America/Boise',
        displayName: 'GMT-07:00 Бойсе MST',
        nameLocalized: 'Бойсе',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 81
    },
    {
        name: 'America/Denver',
        displayName: 'GMT-07:00 Денвер MST',
        nameLocalized: 'Денвер',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 100,
        enabled: true
    },
    {
        name: 'America/Dawson',
        displayName: 'GMT-07:00 Доусон MST',
        nameLocalized: 'Доусон',
        abbreviationStandard: 'MST',
        id: 98
    },
    {
        name: 'America/Dawson_Creek',
        displayName: 'GMT-07:00 Доусон-Крик MST',
        nameLocalized: 'Доусон-Крик',
        abbreviationStandard: 'MST',
        id: 99
    },
    {
        name: 'America/Inuvik',
        displayName: 'GMT-07:00 Инувик MST',
        nameLocalized: 'Инувик',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 129
    },
    {
        name: 'America/Cambridge_Bay',
        displayName: 'GMT-07:00 Кеймбридж-Бей MST',
        nameLocalized: 'Кеймбридж-Бей',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 83
    },
    {
        name: 'America/Mazatlan',
        displayName: 'GMT-07:00 Масатлан MST',
        nameLocalized: 'Масатлан',
        abbreviationStandard: 'MST',
        id: 145
    },
    {
        name: 'America/Whitehorse',
        displayName: 'GMT-07:00 Уайтхорс MST',
        nameLocalized: 'Уайтхорс',
        abbreviationStandard: 'MST',
        id: 198
    },
    {
        name: 'America/Phoenix',
        displayName: 'GMT-07:00 Финикс MST',
        nameLocalized: 'Финикс',
        abbreviationStandard: 'MST',
        id: 166,
        enabled: true
    },
    {
        name: 'America/Edmonton',
        displayName: 'GMT-07:00 Эдмонтон MST',
        nameLocalized: 'Эдмонтон',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 103
    },
    {
        name: 'America/Hermosillo',
        displayName: 'GMT-07:00 Эрмосильо MST',
        nameLocalized: 'Эрмосильо',
        abbreviationStandard: 'MST',
        id: 120
    },
    {
        name: 'Mexico/BajaSur',
        displayName: 'GMT-07:00 BajaSur MST',
        nameLocalized: 'BajaSur',
        abbreviationStandard: 'MST',
        id: 478
    },
    {
        name: 'Etc/GMT-7',
        displayName: 'GMT-07:00 GMT-7 -07',
        nameLocalized: 'GMT-7',
        abbreviationStandard: '-07',
        id: 381
    },
    {
        name: 'Etc/GMT+7',
        displayName: 'GMT-07:00 GMT+7 -07',
        nameLocalized: 'GMT+7',
        abbreviationStandard: '-07',
        id: 366
    },
    {
        name: 'Canada/Mountain',
        displayName: 'GMT-07:00 Mountain MST',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 340
    },
    {
        name: 'MST',
        displayName: 'GMT-07:00 MST MST',
        nameLocalized: 'MST',
        abbreviationStandard: 'MST',
        id: 480
    },
    {
        name: 'MST7MDT',
        displayName: 'GMT-07:00 MST7MDT MST',
        nameLocalized: 'MST7MDT',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 481
    },
    {
        name: 'America/Yellowknife',
        displayName: 'GMT-07:00 Yellowknife MST',
        nameLocalized: 'Yellowknife',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 201
    },
    {
        name: 'Canada/Yukon',
        displayName: 'GMT-07:00 Yukon MST',
        nameLocalized: 'Yukon',
        abbreviationStandard: 'MST',
        id: 344
    },
    {
        name: 'America/Vancouver',
        displayName: 'GMT-08:00 Ванкувер PST',
        nameLocalized: 'Ванкувер',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 196
    },
    {
        name: 'America/Los_Angeles',
        displayName: 'GMT-08:00 Лос-Анджелес PST',
        nameLocalized: 'Лос-Анджелес',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 139,
        enabled: true
    },
    {
        name: 'Pacific/Pitcairn',
        displayName: 'GMT-08:00 Питкэрн -08',
        nameLocalized: 'Питкэрн',
        abbreviationStandard: '-08',
        id: 512
    },
    {
        name: 'America/Tijuana',
        displayName: 'GMT-08:00 Тихуана PST',
        nameLocalized: 'Тихуана',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 193,
        enabled: true
    },
    {
        name: 'America/Ensenada',
        displayName: 'GMT-08:00 Ensenada PST',
        nameLocalized: 'Ensenada',
        abbreviationStandard: 'PST',
        id: 106
    },
    {
        name: 'Etc/GMT-8',
        displayName: 'GMT-08:00 GMT-8 -08',
        nameLocalized: 'GMT-8',
        abbreviationStandard: '-08',
        id: 382
    },
    {
        name: 'Etc/GMT+8',
        displayName: 'GMT-08:00 GMT+8 -08',
        nameLocalized: 'GMT+8',
        abbreviationStandard: '-08',
        id: 367
    },
    {
        name: 'Canada/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 342
    },
    {
        name: 'US/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 545
    },
    {
        name: 'PST8PDT',
        displayName: 'GMT-08:00 PST8PDT PST',
        nameLocalized: 'PST8PDT',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 528
    },
    {
        name: 'Pacific/Marquesas',
        displayName: 'GMT-09:30 Маркизские о-ва -0930',
        nameLocalized: 'Маркизские о-ва',
        abbreviationStandard: '-0930',
        id: 504
    },
    {
        name: 'America/Anchorage',
        displayName: 'GMT-09:00 Анкоридж AKST',
        nameLocalized: 'Анкоридж',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 55
    },
    {
        name: 'America/Juneau',
        displayName: 'GMT-09:00 Джуно AKST',
        nameLocalized: 'Джуно',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 133,
        enabled: true
    },
    {
        name: 'America/Nome',
        displayName: 'GMT-09:00 Ном AKST',
        nameLocalized: 'Ном',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 159
    },
    {
        name: 'Pacific/Gambier',
        displayName: 'GMT-09:00 о-ва Гамбье -09',
        nameLocalized: 'о-ва Гамбье',
        abbreviationStandard: '-09',
        id: 495
    },
    {
        name: 'America/Yakutat',
        displayName: 'GMT-09:00 Якутат AKST',
        nameLocalized: 'Якутат',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 200
    },
    {
        name: 'US/Alaska',
        displayName: 'GMT-09:00 Alaska AKST',
        nameLocalized: 'Alaska',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 535
    },
    {
        name: 'Etc/GMT-9',
        displayName: 'GMT-09:00 GMT-9 -09',
        nameLocalized: 'GMT-9',
        abbreviationStandard: '-09',
        id: 383
    },
    {
        name: 'Etc/GMT+9',
        displayName: 'GMT-09:00 GMT+9 -09',
        nameLocalized: 'GMT+9',
        abbreviationStandard: '-09',
        id: 368
    },
    {
        name: 'America/Adak',
        displayName: 'GMT-10:00 Адак HST',
        nameLocalized: 'Адак',
        abbreviationStandard: 'HST',
        abbreviationDaylight: 'HDT',
        id: 54
    },
    {
        name: 'Pacific/Honolulu',
        displayName: 'GMT-10:00 Гонолулу HST',
        nameLocalized: 'Гонолулу',
        abbreviationStandard: 'HST',
        id: 498,
        enabled: true
    },
    {
        name: 'Pacific/Rarotonga',
        displayName: 'GMT-10:00 Раротонга -10/-0930',
        nameLocalized: 'Раротонга',
        abbreviationStandard: '-10/-0930',
        id: 515
    },
    {
        name: 'Pacific/Tahiti',
        displayName: 'GMT-10:00 Таити -10',
        nameLocalized: 'Таити',
        abbreviationStandard: '-10',
        id: 518
    },
    {
        name: 'Etc/GMT-10',
        displayName: 'GMT-10:00 GMT-10 -10',
        nameLocalized: 'GMT-10',
        abbreviationStandard: '-10',
        id: 371
    },
    {
        name: 'Etc/GMT+10',
        displayName: 'GMT-10:00 GMT+10 -10',
        nameLocalized: 'GMT+10',
        abbreviationStandard: '-10',
        id: 358
    },
    {
        name: 'US/Hawaii',
        displayName: 'GMT-10:00 Hawaii HST',
        nameLocalized: 'Hawaii',
        abbreviationStandard: 'HST',
        id: 541
    },
    {
        name: 'HST',
        displayName: 'GMT-10:00 HST HST',
        nameLocalized: 'HST',
        abbreviationStandard: 'HST',
        id: 457
    },
    {
        name: 'Pacific/Johnston',
        displayName: 'GMT-10:00 Johnston HST',
        nameLocalized: 'Johnston',
        abbreviationStandard: 'HST',
        id: 499
    },
    {
        name: 'Pacific/Niue',
        displayName: 'GMT-11:00 Ниуэ -11',
        nameLocalized: 'Ниуэ',
        abbreviationStandard: '-11',
        id: 507
    },
    {
        name: 'Pacific/Midway',
        displayName: 'GMT-11:00 о-ва Мидуэй SST',
        nameLocalized: 'о-ва Мидуэй',
        abbreviationStandard: 'SST',
        id: 505,
        enabled: true
    },
    {
        name: 'Pacific/Pago_Pago',
        displayName: 'GMT-11:00 Паго-Паго SST',
        nameLocalized: 'Паго-Паго',
        abbreviationStandard: 'SST',
        id: 510
    },
    {
        name: 'Etc/GMT-11',
        displayName: 'GMT-11:00 GMT-11 -11',
        nameLocalized: 'GMT-11',
        abbreviationStandard: '-11',
        id: 372
    },
    {
        name: 'Etc/GMT+11',
        displayName: 'GMT-11:00 GMT+11 -11',
        nameLocalized: 'GMT+11',
        abbreviationStandard: '-11',
        id: 359
    },
    {
        name: 'Pacific/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 517
    },
    {
        name: 'US/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 547
    },
    {
        name: 'Etc/GMT-12',
        displayName: 'GMT-12:00 GMT-12 -12',
        nameLocalized: 'GMT-12',
        abbreviationStandard: '-12',
        id: 373
    },
    {
        name: 'Etc/GMT+12',
        displayName: 'GMT-12:00 GMT+12 -12',
        nameLocalized: 'GMT+12',
        abbreviationStandard: '-12',
        id: 360
    },
];

const weekData: WeekData = {
    firstDay: 1,
    weekendStart: 6,
    weekendEnd: 0
};

const weekDayNames: WeekDayNameData = {
    days: {
        abbreviated: {
            sun: 'вс',
            mon: 'пн',
            tue: 'вт',
            wed: 'ср',
            thu: 'чт',
            fri: 'пт',
            sat: 'сб',
        },
        narrow: {
            sun: 'В',
            mon: 'П',
            tue: 'В',
            wed: 'С',
            thu: 'Ч',
            fri: 'П',
            sat: 'С',
        },
        short: {
            sun: 'вс',
            mon: 'пн',
            tue: 'вт',
            wed: 'ср',
            thu: 'чт',
            fri: 'пт',
            sat: 'сб',
        },
        wide: {
            sun: 'воскресенье',
            mon: 'понедельник',
            tue: 'вторник',
            wed: 'среда',
            thu: 'четверг',
            fri: 'пятница',
            sat: 'суббота',
        },
    },
    standAlone: {
        abbreviated: {
            sun: 'вс',
            mon: 'пн',
            tue: 'вт',
            wed: 'ср',
            thu: 'чт',
            fri: 'пт',
            sat: 'сб',
        },
        narrow: {
            sun: 'В',
            mon: 'П',
            tue: 'В',
            wed: 'С',
            thu: 'Ч',
            fri: 'П',
            sat: 'С',
        },
        short: {
            sun: 'вс',
            mon: 'пн',
            tue: 'вт',
            wed: 'ср',
            thu: 'чт',
            fri: 'пт',
            sat: 'сб',
        },
        wide: {
            sun: 'воскресенье',
            mon: 'понедельник',
            tue: 'вторник',
            wed: 'среда',
            thu: 'четверг',
            fri: 'пятница',
            sat: 'суббота',
        },
    },
};

const data: LocaleData = {
    languages,
    numbers,
    timezones,
    weekData,
    weekDayNames
};

export default data;
